window.NearbyInstallersMap = window.NearbyInstallersMap || {};

window.NearbyInstallersMap.loadGoogleMaps = function loadGoogleMaps(apiKey) {
  if (window.google?.maps) {
    return Promise.resolve();
  }

  window.__nimMapsQueue = window.__nimMapsQueue || [];

  return new Promise((resolve, reject) => {
    window.__nimMapsQueue.push({ resolve, reject });

    if (!window.__nimMapsReady) {
      window.__nimMapsReady = function __nimMapsReady() {
        window.__nimMapsLoading = false;
        const queue = window.__nimMapsQueue || [];
        window.__nimMapsQueue = [];
        queue.forEach(({ resolve: done }) => done());
      };
    }

    if (document.querySelector("script[data-nim-gmaps]")) {
      return;
    }

    window.__nimMapsLoading = true;

    const script = document.createElement("script");
    script.src =
      "https://maps.googleapis.com/maps/api/js?key=" +
      encodeURIComponent(apiKey) +
      "&loading=async&callback=__nimMapsReady";
    script.async = true;
    script.defer = true;
    script.dataset.nimGmaps = "true";
    script.onerror = () => {
      window.__nimMapsLoading = false;
      const queue = window.__nimMapsQueue || [];
      window.__nimMapsQueue = [];
      queue.forEach(({ reject: fail }) => fail(new Error("Failed to load Google Maps")));
    };
    document.head.appendChild(script);
  });
};

window.NearbyInstallersMap.ensureAsset = function ensureAsset(config) {
  return new Promise((resolve) => {
    if (window.NearbyInstallersMap.init) {
      resolve();
      return;
    }

    const existing = document.querySelector("script[data-nim-asset]");
    if (!existing && config.assetUrl) {
      const script = document.createElement("script");
      script.src = config.assetUrl;
      script.dataset.nimAsset = "true";
      script.onload = () => resolve();
      script.onerror = () => resolve();
      document.head.appendChild(script);
      return;
    }

    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (window.NearbyInstallersMap.init) {
        window.clearInterval(timer);
        resolve();
      } else if (attempts > 200) {
        window.clearInterval(timer);
        resolve();
      }
    }, 50);
  });
};

window.NearbyInstallersMap.scrollSectionIntoView = function scrollNearbyMapSectionIntoView(root) {
  if (!root || typeof window === "undefined") return;

  const sectionEl = root.closest(".shopify-section") || root;
  const target =
    sectionEl.querySelector("[data-anchor-target-id]") ||
    document.querySelector('[data-anchor-target-id="map"]') ||
    sectionEl;

  const header = document.querySelector(".header");
  const headerHeight = header ? header.offsetHeight : 0;
  const targetTop = target.getBoundingClientRect().top + window.scrollY;

  window.scrollTo({
    top: Math.max(0, targetTop - headerHeight - 10),
    behavior: "smooth",
  });
};

window.NearbyInstallersMap.hasAddressInUrl = function hasAddressInUrl() {
  try {
    const address = new URLSearchParams(window.location.search).get("address");
    return Boolean(address?.trim());
  } catch {
    return false;
  }
};

window.NearbyInstallersMap.setMapLoadingEarly = function setMapLoadingEarly(
  sectionId,
  loading,
  message = "Loading map…"
) {
  const overlay = document.getElementById(`map-loading-${sectionId}`);
  const textEl = document.getElementById(`map-loading-text-${sectionId}`);
  if (!overlay) return;

  overlay.hidden = !loading;
  overlay.setAttribute("aria-busy", loading ? "true" : "false");
  if (textEl && message) textEl.textContent = message;
};

window.NearbyInstallersMap.boot = function bootNearbyInstallersMap(sectionId, config) {
  const root = document.querySelector('[data-section-id="' + sectionId + '"]');
  if (!root) return;
  if (root.dataset.nimBootStarted === "true") return;
  root.dataset.nimBootStarted = "true";

  window.NearbyInstallersMap.setMapLoadingEarly(sectionId, true, "Loading map…");

  if (window.NearbyInstallersMap.hasAddressInUrl()) {
    window.NearbyInstallersMap.scrollSectionIntoView(root);
  }

  const runBoot = () => {
    window.NearbyInstallersMap.ensureAsset(config)
      .then(() => {
        if (!window.NearbyInstallersMap.init) {
          console.error("NearbyInstallersMap: asset failed to load");
          return;
        }

        return window.NearbyInstallersMap.loadGoogleMaps(config.googleMapsApiKey).then(() =>
          window.NearbyInstallersMap.init(root, config)
        );
      })
      .catch((error) => {
        console.error("NearbyInstallersMap boot failed:", error);
        window.NearbyInstallersMap.setMapLoadingEarly(sectionId, false);
      });
  };

  const sectionEl = root.closest(".shopify-section") || root;
  const shouldDeferUntilVisible = config.deferUntilVisible !== false;

  const scheduleBoot = () => {
    const run = () => runBoot();
    if (typeof window.requestIdleCallback === "function") {
      window.requestIdleCallback(run, { timeout: 1500 });
      return;
    }
    window.setTimeout(run, 0);
  };

  if (typeof IntersectionObserver === "function" && shouldDeferUntilVisible) {
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        scheduleBoot();
      },
      { root: null, rootMargin: "80px", threshold: 0.01 }
    );
    observer.observe(sectionEl);
    return;
  }

  scheduleBoot();
};

window.NearbyInstallersMap.init = function initNearbyInstallersMap(root, config) {
  if (!root || root.dataset.nimInitialized === "true") return;
  root.dataset.nimInitialized = "true";

  const sectionId = config.sectionId;
  const $ = (selector) => {
    if (selector.startsWith(".") || selector.startsWith("[")) {
      return root.querySelector(selector);
    }
    return root.querySelector(`#${selector}-${sectionId}`);
  };
  const $$ = (selector) => root.querySelectorAll(selector);

  setMapLoading(true, "Loading map…");

const GOOGLE_MAPS_API_KEY = config.googleMapsApiKey;
    const GOOGLE_MAP_ID = config.googleMapId;
    const API_BASE_URL = (config.apiBaseUrl || "https://www.yarbo.com/apps/report").replace(/\/$/, "");
    const NEARBY_PROVIDER_API_URL = `${API_BASE_URL}/front/installation/provider/nearby`;
    const SERVICE_LIST_API_URL = `${API_BASE_URL}/front/installation/provider/service/list`;
    const REPAIR_SUBMIT_API_URL = `${API_BASE_URL}/front/installation/provider/repair/submit`;
    const repairSiteListApiPath = String(
      config.repairSiteListApiPath || config.repairSiteMapApiPath || "/front/repair/site/list"
    ).replace(/^\//, "");
    const REPAIR_SITE_LIST_API_URL = `${API_BASE_URL}/${repairSiteListApiPath}`;
    const REPAIR_SITE_TYPE_LIST_API_URL = `${API_BASE_URL}/front/repair/site/type/list`;
    const REPAIR_SITE_METHOD_LIST_API_URL = `${API_BASE_URL}/front/repair/site/method/list`;
    const REPAIR_SITE_TYPE_DETAIL_LIST_API_URL = `${API_BASE_URL}/front/repair/site/type/detail/list`;
    const REPAIR_SITE_METHOD_DETAIL_LIST_API_URL = `${API_BASE_URL}/front/repair/site/method/detail/list`;
    const REPAIR_SITE_MARKER_FALLBACK_COLOR = "#c2410c";
    const SEARCH_PLACEHOLDER =
      config.searchPlaceholder || "Enter your address to find nearby volunteer installers.";
    const GLOBO_FIELD_MAP = {
      "hidden-2": "uid",
      "name-1": "name",
      "phone-1": "phone",
      "email-1": "email",
      "text-1": "addressLine1",
      "text-2": "addressLine2",
      "text-3": "city",
      "text-4": "province",
      "text-5": "zipCode",
      "country-1": "country",
      "select-1": "productName",
      "radio-3": "serviceType",
      "datetime-1": "preferredInstallTime",
      "radio-1": "budget",
      "textarea-2": "otherInfo",
    };
    const GLOBO_APPEND_TO_OTHER_INFO = {
      "radio-2": "Antenna mounting",
      "number-1": "Number of floors",
      "number-2": "Courtyard size (sq ft / m²)",
    };
    const PREDICTION_DEBOUNCE_MS = 400;
    const PREDICTION_MIN_CHARS = 3;
    const DEFAULT_MAP_CENTER = { lat: 41.5, lng: -81.6 };
    const DEFAULT_MAP_ZOOM = 7;
    const INITIAL_MAP_ZOOM = 9;
    const FOCUS_MAP_ZOOM = 11;
    const MAP_VIEWPORT_SYNC_DEBOUNCE_MS = 400;
    const MAX_VIEWPORT_MAP_MARKERS = 80;
    const MAX_SEARCH_MODE_MAP_MARKERS = 250;
    const LARGE_DATASET_THRESHOLD = 500;
    const LIST_PAGE_SIZE = 10;
    const LIST_SCROLL_LOAD_THRESHOLD_PX = 96;

    let map;
    let userMarker;
    let infoWindow = null;
    let suppressInfoWindowCloseSelectionReset = false;
    let AdvancedMarkerElement;
    let PinElement;
    let placeAutocomplete;
    let AutocompleteSuggestion;
    let AutocompleteSessionToken;
    let Place;
    let sessionToken;
    let placesLibraryPromise = null;
    let currentLocation = null;
    let currentAddress = "";
    let currentRawInput = "";
    let providers = [];
    let serviceOptions = [];
    let serviceOptionsById = new Map();
    let serviceOptionsByNormalizedName = new Map();
    let serviceNormalizedNameById = new Map();
    let selectedProviderTypes = new Set();
    let selectedServiceIds = new Set();
    let providerMarkers = new Map();
    let activeProviderId = null;
    let selectedProviderForRequest = null;
    let currentRepairRequestUid = null;
    let repairFormSubmitInFlight = false;
    let lastSubmittedRepairUid = null;
    let repairFormSubmitBound = false;
    let repairFormSuccessObserver = null;
    let repairSubmitButtonObserver = null;
    let repairSuccessHandled = false;
    let repairSubmitTimers = [];
    let handleRepairFormSubmit = null;
    let handleRepairFormCustomEvent = null;
    let globoInitTimeouts = [];
    let listEmptyMessage = "";
    let hasActiveSearch = false;
    let lastSearchAddress = null;
    let lastSearchPlaceId = null;
    let predictionDebounceTimer = null;
    let predictionRequestId = 0;
    let lastProviderCountText = "";
    let handleRootClick = null;
    let handleDocumentClick = null;
    let handleWindowResize = null;
    let windowResizeTimer = null;
    let prefetchedAllProvidersPromise = null;
    let activeTab = "install";
    let repairSites = [];
    let repairSiteOptions = [];
    let repairMethodOptions = [];
    let providerTypeColorsByName = new Map();
    let selectedRepairSiteTypes = new Set();
    let selectedRepairMethods = new Set();
    let repairMarkers = new Map();
    let activeRepairSiteId = null;
    let repairListEmptyMessage = "";
    let hasActiveRepairSearch = false;
    let repairSitesLoaded = false;
    let repairSitesLoading = false;
    let repairFilterOptionsLoaded = false;
    let repairFilterOptionsLoading = false;
    let lastRepairSearchCacheKey = null;
    let lastRepairSearchAddress = null;
    let lastRepairSearchPlaceId = null;
    let lastRepairSiteCountText = "";
    let viewportSyncTimer = null;
    let repairViewportSyncTimer = null;
    let mapViewportListeners = [];
    let lastSyncedBoundsKey = "";
    let lastRepairSyncedBoundsKey = "";
    let suppressViewportSyncEvents = false;
    let filterLoadingTimer = null;
    let pendingFilterLoadingHide = null;
    let tabSwitchInProgress = false;
    let providerVirtualList = null;
    let repairVirtualList = null;
    let mobileSheetSelectedProviderId = null;
    let mobileSheetSelectedRepairSiteId = null;
    let mobileFilterUiBound = false;
    let mobileLayoutMediaQuery = null;
    const FILTER_LOADING_MIN_MS = 180;

    function setStatus(message, isError = false) {
      const bar = $("status-bar");
      bar.textContent = message;
      bar.classList.toggle("error", isError);
    }

    function setMapLoading(loading, message = "Loading map…") {
      const overlay = $("map-loading");
      if (!overlay) return;
      overlay.hidden = !loading;
      overlay.setAttribute("aria-busy", loading ? "true" : "false");
      $("map-loading-text").textContent = message;
    }

    function getInstallTabPanel() {
      return root.querySelector('[data-tab-panel="install"]');
    }

    function setListLoading(loading, message = "Loading providers…") {
      const overlay = $("list-loading");
      const panel = getInstallTabPanel();
      if (!overlay) return;
      overlay.hidden = !loading;
      overlay.classList.toggle("is-filter-only", false);
      panel?.classList.toggle("is-loading", loading);
      $("list-loading-text").textContent = message;
    }

    function setRepairListLoading(loading, message = "Loading repair sites…") {
      const overlay = $("repair-list-loading");
      const panel = root.querySelector('[data-tab-panel="repair"]');
      if (!overlay) return;
      overlay.hidden = !loading;
      overlay.classList.toggle("is-filter-only", false);
      panel?.classList.toggle("is-loading", loading);
      $("repair-list-loading-text").textContent = message;
    }

    function setInstallFilterLoading(loading, message = "Applying filters…") {
      const overlay = $("list-loading");
      const panel = getInstallTabPanel();
      if (!overlay) return;
      overlay.hidden = !loading;
      overlay.classList.toggle("is-filter-only", loading);
      panel?.classList.toggle("is-loading", loading);
      $("list-loading-text").textContent = message;
    }

    function setRepairFilterLoading(loading, message = "Applying filters…") {
      const overlay = $("repair-list-loading");
      const panel = root.querySelector('[data-tab-panel="repair"]');
      if (!overlay) return;
      overlay.hidden = !loading;
      overlay.classList.toggle("is-filter-only", loading);
      panel?.classList.toggle("is-loading", loading);
      $("repair-list-loading-text").textContent = message;
    }

    function clearFilterLoadingTimer() {
      if (filterLoadingTimer) {
      window.clearTimeout(filterLoadingTimer);
      filterLoadingTimer = null;
      }

      if (pendingFilterLoadingHide) {
        pendingFilterLoadingHide(false);
        pendingFilterLoadingHide = null;
      }
    }

    function clearAllListLoadingStates() {
      clearFilterLoadingTimer();
      setPageLoading(false);
      setRepairListLoading(false);
    }

    function isMobileNimUi() {
      return Boolean(mobileLayoutMediaQuery?.matches);
    }

    function isMobileFilterSheetOpen() {
      return root.classList.contains("is-mobile-sheet-open");
    }

    function formatMobileToolbarCountText() {
      const count = isRepairTabActive()
        ? getFilteredRepairSites().length
        : getFilteredProviders().length;
      return `${count} Item(s) Found`;
    }

    function updateMobileToolbarCount() {
      const countEl = $("mobile-toolbar-count");
      if (!countEl || !isMobileNimUi()) return;
      countEl.textContent = formatMobileToolbarCountText();
    }

    function syncMobileSheetSelectionClasses() {
      if (!isMobileFilterSheetOpen()) return;

      const selectedId = isRepairTabActive()
        ? mobileSheetSelectedRepairSiteId
        : mobileSheetSelectedProviderId;
      const attr = isRepairTabActive() ? "data-repair-site-id" : "data-provider-id";

      root.querySelectorAll(".provider-card.mobile-sheet-selected").forEach((card) => {
        card.classList.remove("mobile-sheet-selected");
      });

      if (selectedId == null) return;

      const card = root.querySelector(
        `.provider-card[${attr}="${CSS.escape(String(selectedId))}"]`
      );
      card?.classList.add("mobile-sheet-selected");
    }

    function setMobileSheetSelectedProvider(providerId) {
      mobileSheetSelectedProviderId = providerId == null ? null : providerId;
      syncMobileSheetSelectionClasses();
      if (providerVirtualList && mobileSheetSelectedProviderId != null) {
        providerVirtualList.scrollToId(mobileSheetSelectedProviderId);
        providerVirtualList.setActiveId(null);
      }
    }

    function setMobileSheetSelectedRepairSite(siteId) {
      mobileSheetSelectedRepairSiteId = siteId == null ? null : siteId;
      syncMobileSheetSelectionClasses();
      if (repairVirtualList && mobileSheetSelectedRepairSiteId != null) {
        repairVirtualList.scrollToId(mobileSheetSelectedRepairSiteId);
        repairVirtualList.setActiveId(null);
      }
    }

    function openMobileFilterSheet() {
      if (!isMobileNimUi()) return;

      hidePredictionsDropdown();
      mobileSheetSelectedProviderId = activeProviderId;
      mobileSheetSelectedRepairSiteId = activeRepairSiteId;
      root.classList.add("is-mobile-sheet-open");
      document.body.style.overflow = "hidden";
      updateMobileToolbarCount();
      if (isRepairTabActive()) {
        renderRepairSiteList();
      } else {
        renderProviderList();
      }
      window.requestAnimationFrame(() => {
        if (isRepairTabActive() && mobileSheetSelectedRepairSiteId != null) {
          repairVirtualList?.scrollToId(mobileSheetSelectedRepairSiteId);
        } else if (!isRepairTabActive() && mobileSheetSelectedProviderId != null) {
          providerVirtualList?.scrollToId(mobileSheetSelectedProviderId);
        }
      });
    }

    function closeMobileFilterSheet() {
      root.classList.remove("is-mobile-sheet-open");
      document.body.style.overflow = "";
      root.querySelectorAll(".provider-card.mobile-sheet-selected").forEach((card) => {
        card.classList.remove("mobile-sheet-selected");
      });
    }

    function getFirstFocusableProvider() {
      const filtered = getFilteredProviders();
      const sorted = filtered
        .map((provider) => ({
          provider,
          distance: getProviderDistance(provider),
        }))
        .sort((a, b) => {
          if (a.distance == null && b.distance == null) return 0;
          if (a.distance == null) return 1;
          if (b.distance == null) return -1;
          return a.distance - b.distance;
        })
        .map((entry) => entry.provider);
      return sorted.find((provider) => provider.lat && provider.lng) || null;
    }

    function getFirstFocusableRepairSite() {
      return getFilteredRepairSites().find((site) => site.lat && site.lng) || null;
    }

    function applyMobileFilterSheet() {
      if (!isMobileNimUi()) return;

      if (isRepairTabActive()) {
        const site =
          repairSites.find(
            (item) => String(item.id) === String(mobileSheetSelectedRepairSiteId)
          ) || getFirstFocusableRepairSite();
        closeMobileFilterSheet();
        if (site) {
          focusRepairSite(site);
        }
        return;
      }

      const provider =
        providers.find((item) => String(item.id) === String(mobileSheetSelectedProviderId)) ||
        getFirstFocusableProvider();
      closeMobileFilterSheet();
      if (provider) {
        focusProvider(provider);
      }
    }

    function initMobileFilterUi() {
      mobileLayoutMediaQuery = window.matchMedia("(max-width: 749px)");
      updateMobileToolbarCount();

      if (mobileFilterUiBound) return;
      mobileFilterUiBound = true;

      $("mobile-filter-open")?.addEventListener("click", openMobileFilterSheet);
      $("mobile-filter-close")?.addEventListener("click", closeMobileFilterSheet);
      $("mobile-filter-apply")?.addEventListener("click", applyMobileFilterSheet);

      const handleMobileLayoutChange = () => {
        updateMobileToolbarCount();
        if (!isMobileNimUi()) {
          closeMobileFilterSheet();
        }
      };

      if (typeof mobileLayoutMediaQuery.addEventListener === "function") {
        mobileLayoutMediaQuery.addEventListener("change", handleMobileLayoutChange);
      } else if (typeof mobileLayoutMediaQuery.addListener === "function") {
        mobileLayoutMediaQuery.addListener(handleMobileLayoutChange);
      }
    }

    function runWithFilterLoading(callback, options = {}) {
      const { repair = isRepairTabActive(), message = "Applying filters…" } = options;
      const showLoading = repair ? setRepairFilterLoading : setInstallFilterLoading;
      const hideLoading = repair ? setRepairFilterLoading : setInstallFilterLoading;

      clearFilterLoadingTimer();
      showLoading(true, message);

      const runDeferredWork = () => {
        try {
          callback();
        } finally {
          pendingFilterLoadingHide = hideLoading;
          filterLoadingTimer = window.setTimeout(() => {
            hideLoading(false);
            filterLoadingTimer = null;
            pendingFilterLoadingHide = null;
          }, FILTER_LOADING_MIN_MS);
        }
      };

      // Paint loading + chip state before filter/map work blocks the main thread.
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(runDeferredWork);
      });
    }

    function setTabSwitchLoading(loading, tab, message) {
      if (tab === "repair") {
        setRepairFilterLoading(loading, message);
        return;
      }

      setInstallFilterLoading(loading, message);
    }

    function setTabsDisabled(disabled) {
      $$("[data-tab]").forEach((button) => {
        button.disabled = disabled;
        button.setAttribute("aria-disabled", disabled ? "true" : "false");
      });
    }

    async function waitForMinimumLoadingDuration(startedAt) {
      const elapsed = Date.now() - startedAt;
      const remaining = Math.max(0, FILTER_LOADING_MIN_MS - elapsed);
      if (!remaining) return;

      await new Promise((resolve) => {
        window.setTimeout(resolve, remaining);
      });
    }

    function setPageLoading(loading, message = "Loading providers…") {
      setListLoading(loading, message);
    }

    function releaseMapLoadingOverlay() {
      setMapLoading(false);
      if (window.NearbyInstallersMap?.setMapLoadingEarly) {
        window.NearbyInstallersMap.setMapLoadingEarly(sectionId, false);
      }
    }

    function yieldToMain() {
      return new Promise((resolve) => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(resolve);
        });
      });
    }

    function setSearchLoading(loading) {
      const button = $("search-btn");
      button.disabled = loading;
      button.classList.toggle("loading", loading);
    }

    function findInputLabelText(input, scope) {
      if (input.id) {
        const label = scope.querySelector(`label[for="${CSS.escape(input.id)}"]`);
        if (label?.textContent) return label.textContent;
      }

      const parentLabel = input.closest("label");
      if (parentLabel?.textContent) return parentLabel.textContent;

      const fieldWrap = input.closest(
        ".globo-form-field, .gf-field, .globo-field, .field, .form-field, [class*='field']"
      );
      if (fieldWrap) {
        const labelEl = fieldWrap.querySelector("label, .label, .field-label, .globo-label");
        if (labelEl?.textContent) return labelEl.textContent;
      }

      return "";
    }

    function matchesGloboHiddenField(input, fieldLabel, scope) {
      const target = String(fieldLabel || "").trim().toLowerCase();
      if (!target) return false;

      const candidates = [
        input.name,
        input.id,
        input.getAttribute("data-field-label"),
        input.getAttribute("data-label"),
        input.getAttribute("aria-label"),
        input.getAttribute("placeholder"),
        findInputLabelText(input, scope),
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();

      return candidates.includes(target) || candidates.includes(target.replace(/\s+/g, ""));
    }

    function setGloboHiddenFieldValue(scope, fieldLabel, value) {
      const hiddenInputs = scope.querySelectorAll('input[type="hidden"]');

      for (const input of hiddenInputs) {
        if (!matchesGloboHiddenField(input, fieldLabel, scope)) continue;

        input.value = value || "";
        input.dispatchEvent(new Event("input", { bubbles: true }));
        input.dispatchEvent(new Event("change", { bubbles: true }));
        return true;
      }

      return false;
    }

    function clearGloboInitTimeouts() {
      globoInitTimeouts.forEach((timeoutId) => window.clearTimeout(timeoutId));
      globoInitTimeouts = [];
    }

    function isGloboSuccessVisible(scope) {
      return Boolean(scope?.querySelector(".message.success"));
    }

    function initGloboDynamicForm(scope) {
      const widget = scope.querySelector(".globo-formbuilder");
      if (!widget || isGloboSuccessVisible(scope)) return;

      document.dispatchEvent(new CustomEvent("globo.formbuilder.init"));
      document.dispatchEvent(new CustomEvent("globoFormBuilderInit"));

      if (typeof window.globoFormbuilderInit === "function") {
        window.globoFormbuilderInit();
      }

      if (typeof window.GloboFormBuilder?.init === "function") {
        window.GloboFormBuilder.init();
      }

      if (window.jQuery) {
        window.jQuery(document).trigger("globo.formbuilder.init");
      }
    }

    function hasRenderedGloboForm(widget) {
      if (!widget) return false;

      return Boolean(
        widget.querySelector(
          "form, input, textarea, select, .globo-form, .g-container, .globo-form-app, .globo-formbuilder-app"
        ) || widget.childElementCount > 0
      );
    }

    function ensureGloboFormRendered(body) {
      const formId = config.globoFormId || "MTY0MTEy";
      let widget = body.querySelector(".globo-formbuilder");

      if (!widget) {
        const mount = document.createElement("div");
        mount.className = "nim-globo-form-mount";
        mount.innerHTML = `<div class="globo-formbuilder" data-id="${formId}"></div>`;
        body.appendChild(mount);
        widget = mount.querySelector(".globo-formbuilder");
      }

      if (!hasRenderedGloboForm(widget)) {
        const fresh = document.createElement("div");
        fresh.className = "globo-formbuilder";
        fresh.setAttribute("data-id", formId);
        widget.replaceWith(fresh);
        widget = fresh;
      }

      clearGloboInitTimeouts();
      initGloboDynamicForm(body);

      globoInitTimeouts.push(
        window.setTimeout(() => {
          if (!hasRenderedGloboForm(widget) && !isGloboSuccessVisible(body)) {
            initGloboDynamicForm(body);
          }
        }, 500)
      );
    }

    function readGloboHiddenFieldValue(scope, fieldLabel) {
      const hiddenInputs = scope.querySelectorAll('input[type="hidden"]');

      for (const input of hiddenInputs) {
        if (!matchesGloboHiddenField(input, fieldLabel, scope)) continue;
        return String(input.value ?? "").trim();
      }

      return "";
    }

    function getRequestServiceBody() {
      return $("request-service-body");
    }

    function getGloboFormContainer(scope) {
      if (!scope) return null;

      return (
        scope.querySelector("form.g-container") ||
        scope.querySelector(".globo-formbuilder form") ||
        scope.querySelector(".globo-form form") ||
        scope.querySelector(".globo-formbuilder-app form") ||
        scope.querySelector(".globo-formbuilder") ||
        scope.querySelector(".globo-form") ||
        scope.querySelector(".globo-formbuilder-app") ||
        scope.querySelector(".g-container") ||
        scope.querySelector(".nim-globo-form-mount") ||
        scope
      );
    }

    function clearRepairSubmitTimers() {
      repairSubmitTimers.forEach((timerId) => window.clearTimeout(timerId));
      repairSubmitTimers = [];
    }

    function scheduleRepairOrderSubmit(scope, delays = [0]) {
      clearRepairSubmitTimers();
      delays.forEach((delay) => {
        const timerId = window.setTimeout(() => {
          queueRepairOrderSubmit(scope);
        }, delay);
        repairSubmitTimers.push(timerId);
      });
    }

    function isGloboFinalSubmitControl(element) {
      if (!element) return false;

      const tagName = String(element.tagName || "").toLowerCase();
      const type = String(element.type || "").toLowerCase();
      const className = String(element.className || "").toLowerCase();

      if (tagName === "input" && type === "submit") return true;
      if (tagName !== "button") return false;
      if (type === "submit") return true;

      return /(?:^|\s)(?:gf-submit|globo-submit|gfb-submit|submit-button|form-submit)(?:\s|$)/.test(
        className
      );
    }

    function findGloboFinalSubmitControl(scope) {
      const container = getGloboFormContainer(scope);
      if (!container) return null;

      const explicit = container.querySelector(
        'button[type="submit"], input[type="submit"], .gf-submit, .globo-submit, .gfb-submit, .submit-button, .form-submit'
      );
      if (explicit) return explicit;

      const candidates = container.querySelectorAll("button, input[type='submit']");
      for (const candidate of candidates) {
        if (isGloboFinalSubmitControl(candidate)) return candidate;
      }

      const actionAreas = container.querySelectorAll(
        ".actions, .form-actions, .gfb-footer, .footer, .globo-form-actions"
      );
      for (const area of actionAreas) {
        const buttons = area.querySelectorAll("button");
        for (const button of buttons) {
          const text = String(button.textContent || "").trim().toLowerCase();
          if (text === "submit" || text === "send" || text === "send request") {
            return button;
          }
        }
      }

      return null;
    }

    function bindGloboFinalSubmitControl(scope) {
      const submitControl = findGloboFinalSubmitControl(scope);
      if (!submitControl || submitControl.dataset.nimRepairSubmitBound === "true") return;

      submitControl.dataset.nimRepairSubmitBound = "true";
      submitControl.addEventListener("click", () => {
        scheduleRepairOrderSubmit(scope, [500, 1200]);
      });
    }

    function watchGloboFinalSubmitControl(scope) {
      if (repairSubmitButtonObserver) {
        repairSubmitButtonObserver.disconnect();
        repairSubmitButtonObserver = null;
      }

      if (!scope) return;

      bindGloboFinalSubmitControl(scope);

      repairSubmitButtonObserver = new MutationObserver(() => {
        bindGloboFinalSubmitControl(scope);
      });

      repairSubmitButtonObserver.observe(scope, { childList: true, subtree: true });
    }

    function unwatchGloboFinalSubmitControl() {
      if (repairSubmitButtonObserver) {
        repairSubmitButtonObserver.disconnect();
        repairSubmitButtonObserver = null;
      }
    }

    function isWithinRequestServiceModal(node) {
      const modal = $("request-service-modal");
      if (!node || modal?.hidden) return false;
      return modal.contains(node);
    }

    function getGloboFieldKey(input) {
      const dataField =
        input.getAttribute("data-field-id") ||
        input.getAttribute("data-gf-field") ||
        input.getAttribute("data-field-key");

      if (dataField) return String(dataField).trim();

      const raw = String(input.name || input.id || "").trim();
      if (!raw) return "";

      const bracketMatch = raw.match(/\[([^\]]+)\]$/);
      return bracketMatch ? bracketMatch[1].trim() : raw;
    }

    function normalizePreferredInstallTime(value) {
      const text = String(value ?? "").trim();
      if (!text) return text;
      if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(text)) return text;

      const date = new Date(text);
      if (Number.isNaN(date.getTime())) return text;

      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const year = date.getFullYear();
      return `${month}/${day}/${year}`;
    }

    function appendOtherInfo(payload, line) {
      const nextLine = String(line ?? "").trim();
      if (!nextLine) return;

      payload.otherInfo = payload.otherInfo ? `${payload.otherInfo}\n${nextLine}` : nextLine;
    }

    function buildRepairSubmitPayload(scope) {
      const payload = {};
      const uid =
        currentRepairRequestUid ||
        scope?.dataset?.repairRequestUid ||
        readGloboHiddenFieldValue(scope, "hidden-2");

      if (uid) payload.uid = uid;

      const container = getGloboFormContainer(scope);
      if (!container) return payload;

      container.querySelectorAll("input, select, textarea").forEach((input) => {
        const inputType = String(input.type || "").toLowerCase();
        if (inputType === "submit" || inputType === "button" || inputType === "file") return;
        if (inputType === "checkbox" || inputType === "radio") {
          if (!input.checked) return;
        }

        const value = String(input.value ?? "").trim();
        if (!value) return;

        const fieldKey = getGloboFieldKey(input);
        const mappedApiKey = GLOBO_FIELD_MAP[fieldKey];

        if (mappedApiKey) {
          payload[mappedApiKey] =
            mappedApiKey === "preferredInstallTime"
              ? normalizePreferredInstallTime(value)
              : value;
          return;
        }

        if (GLOBO_APPEND_TO_OTHER_INFO[fieldKey]) {
          appendOtherInfo(payload, `${GLOBO_APPEND_TO_OTHER_INFO[fieldKey]}: ${value}`);
        }
      });

      if (!payload.uid && uid) {
        payload.uid = uid;
      }

      return payload;
    }

    async function submitRepairOrderToBackend(payload) {
      if (!payload?.uid) {
        throw new Error("Repair submit payload is missing uid");
      }

      const response = await fetch(REPAIR_SUBMIT_API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`API returned ${response.status}`);
      }

      const result = await response.json();
      if (result.code !== 200) {
        throw new Error(result.msg || "Failed to submit repair order");
      }

      return result;
    }

    async function syncRepairOrderSubmit(scope) {
      if (repairFormSubmitInFlight || !scope) return;

      const payload = buildRepairSubmitPayload(scope);
      if (!payload.uid) {
        console.warn("NearbyInstallersMap: repair submit skipped, missing uid");
        return;
      }

      if (lastSubmittedRepairUid === payload.uid) return;

      repairFormSubmitInFlight = true;
      try {
        await submitRepairOrderToBackend(payload);
        lastSubmittedRepairUid = payload.uid;
      } finally {
        repairFormSubmitInFlight = false;
      }
    }

    function queueRepairOrderSubmit(scope) {
      const targetScope = scope || getRequestServiceBody();
      if (!targetScope) return;

      syncRepairOrderSubmit(targetScope).catch((error) => {
        console.error("NearbyInstallersMap repair submit failed:", error);
      });
    }

    function unwatchRepairFormSuccess() {
      if (repairFormSuccessObserver) {
        repairFormSuccessObserver.disconnect();
        repairFormSuccessObserver = null;
      }
    }

    function watchRepairFormSuccess(scope) {
      unwatchRepairFormSuccess();
      repairSuccessHandled = false;
      if (!scope) return;

      repairFormSuccessObserver = new MutationObserver(() => {
        if (repairSuccessHandled || !isGloboSuccessVisible(scope)) return;
        repairSuccessHandled = true;
        scheduleRepairOrderSubmit(scope, [0]);
      });

      repairFormSuccessObserver.observe(scope, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["class", "style", "hidden"],
      });
    }

    function bindRepairFormSubmitListeners() {
      if (repairFormSubmitBound) return;
      repairFormSubmitBound = true;

      handleRepairFormSubmit = (event) => {
        const body = getRequestServiceBody();
        const modal = $("request-service-modal");
        if (!body || modal?.hidden) return;
        if (!(event.target instanceof HTMLFormElement)) return;
        if (!body.contains(event.target)) return;

        scheduleRepairOrderSubmit(body, [500, 1200]);
      };

      handleRepairFormCustomEvent = () => {
        const body = getRequestServiceBody();
        const modal = $("request-service-modal");
        if (!body || modal?.hidden) return;
        scheduleRepairOrderSubmit(body, [0]);
      };

      document.addEventListener("submit", handleRepairFormSubmit, true);

      [
        "globo.formbuilder.submit",
        "globo.formbuilder.afterSubmit",
        "globoFormBuilder.afterSubmit",
        "globoFormBuilder.submit",
      ].forEach((eventName) => {
        document.addEventListener(eventName, handleRepairFormCustomEvent);
      });

      if (window.jQuery) {
        window.jQuery(document).on(
          "globo.formbuilder.submit globo.formbuilder.afterSubmit globoFormBuilder.afterSubmit globoFormBuilder.submit",
          handleRepairFormCustomEvent
        );
      }
    }

    function unbindRepairFormSubmitListeners() {
      clearRepairSubmitTimers();
      unwatchRepairFormSuccess();
      unwatchGloboFinalSubmitControl();

      if (handleRepairFormSubmit) {
        document.removeEventListener("submit", handleRepairFormSubmit, true);
        handleRepairFormSubmit = null;
      }

      if (handleRepairFormCustomEvent) {
        [
          "globo.formbuilder.submit",
          "globo.formbuilder.afterSubmit",
          "globoFormBuilder.afterSubmit",
          "globoFormBuilder.submit",
        ].forEach((eventName) => {
          document.removeEventListener(eventName, handleRepairFormCustomEvent);
        });

        if (window.jQuery) {
          window.jQuery(document).off(
            "globo.formbuilder.submit globo.formbuilder.afterSubmit globoFormBuilder.afterSubmit globoFormBuilder.submit",
            handleRepairFormCustomEvent
          );
        }

        handleRepairFormCustomEvent = null;
      }

      repairFormSubmitBound = false;
    }

    function createRepairRequestUid() {
      if (window.crypto?.randomUUID) {
        return window.crypto.randomUUID();
      }

      return `nim-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
    }

    function applyGloboHiddenFields(body, fields) {
      const pendingFields = fields.filter((field) => field.value != null && field.value !== "");
      if (!pendingFields.length) return;

      const applyAllHiddenFields = () => {
        let appliedCount = 0;

        pendingFields.forEach((field) => {
          if (setGloboHiddenFieldValue(body, field.label, field.value)) {
            appliedCount += 1;
          }
        });

        return appliedCount === pendingFields.length;
      };

      if (applyAllHiddenFields()) return;

      const observer = new MutationObserver(() => {
        if (applyAllHiddenFields()) observer.disconnect();
      });

      observer.observe(body, { childList: true, subtree: true, attributes: true });
      window.setTimeout(() => observer.disconnect(), 15000);
    }

    function applyRequestServiceHiddenFields(body, provider) {
      currentRepairRequestUid = createRepairRequestUid();

      applyGloboHiddenFields(body, [
        {
          label: "hidden-1",
          value: provider?.email || "",
        },
        {
          label: config.globoProviderEmailFieldLabel || "service email",
          value: provider?.email || "",
        },
        {
          label: "hidden-2",
          value: currentRepairRequestUid,
        },
        {
          label: config.globoUidFieldLabel || "uid",
          value: currentRepairRequestUid,
        },
      ]);

      body.dataset.repairRequestUid = currentRepairRequestUid;
    }

    function openRequestServiceModal(provider) {
      selectedProviderForRequest = provider;
      const body = $("request-service-body");

      $("request-service-modal").hidden = false;
      ensureGloboFormRendered(body);
      applyRequestServiceHiddenFields(body, provider);
      watchRepairFormSuccess(body);
      watchGloboFinalSubmitControl(body);
    }

    function closeRequestServiceModal() {
      $("request-service-modal").hidden = true;
      selectedProviderForRequest = null;
      currentRepairRequestUid = null;
      repairSuccessHandled = false;
      clearRepairSubmitTimers();
      unwatchRepairFormSuccess();
      unwatchGloboFinalSubmitControl();
      clearGloboInitTimeouts();
    }

    async function fetchServiceOptions() {
      const response = await fetch(SERVICE_LIST_API_URL);
      if (!response.ok) {
        throw new Error(`API returned ${response.status}`);
      }

      const result = await response.json();
      if (result.code !== 200) {
        throw new Error(result.msg || "Failed to load services");
      }

      return Array.isArray(result.data) ? result.data : [];
    }

    function normalizeRepairOptionList(data) {
      if (!Array.isArray(data)) return [];
      return data.map((item) => String(item ?? "").trim()).filter(Boolean);
    }

    function normalizeRepairOptionDetailList(data) {
      if (!Array.isArray(data)) return [];

      return data
        .map((item) => {
          if (typeof item === "string") {
            const optionName = item.trim();
            return optionName
              ? { id: null, optionName, backgroundColor: null, textColor: null }
              : null;
          }

          const optionName = String(
            item.optionName || item.typeName || item.methodName || item.name || ""
          ).trim();
          if (!optionName) return null;

          return {
            id: item.id ?? null,
            optionName,
            backgroundColor: item.backgroundColor ?? null,
            textColor: item.textColor ?? null,
          };
        })
        .filter(Boolean);
    }

    async function fetchRepairOptionList(url, errorMessage) {
      const response = await fetch(url, { method: "POST" });

      if (!response.ok) {
        throw new Error(`API returned ${response.status}`);
      }

      const result = await response.json();
      if (result.code !== 200) {
        throw new Error(result.msg || errorMessage);
      }

      return normalizeRepairOptionList(result.data);
    }

    async function fetchRepairOptionDetailList(url, errorMessage) {
      const response = await fetch(url, { method: "POST" });

      if (!response.ok) {
        throw new Error(`API returned ${response.status}`);
      }

      const result = await response.json();
      if (result.code !== 200) {
        throw new Error(result.msg || errorMessage);
      }

      return normalizeRepairOptionDetailList(result.data);
    }

    async function fetchRepairSiteTypeOptions() {
      try {
        const details = await fetchRepairOptionDetailList(
          REPAIR_SITE_TYPE_DETAIL_LIST_API_URL,
          "Failed to load repair site type details"
        );
        if (details.length) return details;
      } catch (error) {
        console.warn("Repair site type detail list unavailable, falling back:", error);
      }

      const names = await fetchRepairOptionList(
        REPAIR_SITE_TYPE_LIST_API_URL,
        "Failed to load repair site types"
      );
      return normalizeRepairOptionDetailList(names);
    }

    async function fetchRepairMethodOptions() {
      try {
        const details = await fetchRepairOptionDetailList(
          REPAIR_SITE_METHOD_DETAIL_LIST_API_URL,
          "Failed to load repair method details"
        );
        if (details.length) return details;
      } catch (error) {
        console.warn("Repair method detail list unavailable, falling back:", error);
      }

      const names = await fetchRepairOptionList(
        REPAIR_SITE_METHOD_LIST_API_URL,
        "Failed to load repair methods"
      );
      return normalizeRepairOptionDetailList(names);
    }

    const OPTION_COLOR_VAR_MAP = {
      bg: "--option-bg",
      text: "--option-text",
      border: "--option-border",
      activeBg: "--option-active-bg",
      activeText: "--option-active-text",
      activeBorder: "--option-active-border",
      dot: "--option-dot",
    };

    function getThemeVar(cssVar) {
      return getComputedStyle(root).getPropertyValue(cssVar).trim();
    }

    function withActiveFromBase(colors) {
      return {
        ...colors,
        activeBg: colors.activeBg || colors.bg,
        activeText: colors.activeText || colors.text,
        activeBorder: colors.activeBorder || colors.border || colors.bg,
      };
    }

    function inferStyleKey(label, kind = "service") {
      const normalized = String(label || "").trim().toLowerCase();
      if (kind === "provider") {
        if (normalized === "dealer") return "dealer";
        if (normalized === "volunteer") return "volunteer";
        if (normalized === "fse") return "fse";
        return "provider";
      }

      if (normalized.includes("mapping")) return "mapping";
      if (normalized.includes("installation")) return "installation";
      return "service";
    }

    function getDefaultColorsByStyleKey(styleKey) {
      const key = String(styleKey || "service").toLowerCase();

      if (key === "installation") {
        const bg = getThemeVar("--nim-service-installation-bg");
        const text = getThemeVar("--nim-service-installation-text");
        return withActiveFromBase({ bg, text, border: bg });
      }

      if (key === "mapping") {
        const bg = getThemeVar("--nim-service-mapping-bg");
        const text = getThemeVar("--nim-service-mapping-text");
        return withActiveFromBase({ bg, text, border: bg });
      }

      if (key === "dealer") {
        const color = getThemeVar("--nim-dealer");
        return {
          dot: color,
          activeBg: "rgba(21, 128, 61, 0.1)",
          activeText: color,
          activeBorder: color,
        };
      }

      if (key === "volunteer") {
        const color = getThemeVar("--nim-volunteer");
        return {
          dot: color,
          activeBg: "rgba(32, 80, 216, 0.08)",
          activeText: color,
          activeBorder: color,
        };
      }

      if (key === "fse") {
        const color = getThemeVar("--nim-fse");
        return {
          dot: color,
          activeBg: "rgba(247, 181, 0, 0.12)",
          activeText: "#9a7200",
          activeBorder: color,
        };
      }

      const text = getThemeVar("--text") || "#25282a";
      const border = getThemeVar("--border") || "#cccccc";
      const installBg = getThemeVar("--nim-service-installation-bg") || text;
      const installText = getThemeVar("--nim-service-installation-text") || "#ffffff";

      if (key === "provider") {
        return {
          dot: text,
          activeBg: "rgba(37, 40, 42, 0.08)",
          activeText: text,
          activeBorder: text,
        };
      }

      return {
        bg: "#ffffff",
        text,
        border,
        activeBg: installBg,
        activeText: installText,
        activeBorder: installBg,
      };
    }

    function pickDefinedColors(colors) {
      if (!colors || typeof colors !== "object") return {};

      const picked = {};
      Object.keys(OPTION_COLOR_VAR_MAP).forEach((key) => {
        const value = colors[key];
        if (value !== undefined && value !== null && String(value).trim() !== "") {
          picked[key] = String(value).trim();
        }
      });
      return picked;
    }

    function normalizeColorValue(value) {
      const normalized = String(value ?? "").trim();
      return normalized || null;
    }

    function markerColorFromOptionColors(colors, fallback) {
      return (
        normalizeColorValue(colors?.activeText) ||
        normalizeColorValue(colors?.text) ||
        normalizeColorValue(colors?.dot) ||
        normalizeColorValue(colors?.bg) ||
        fallback
      );
    }

    function mergeApiOptionColors(option, colors) {
      const backgroundColor = normalizeColorValue(option?.backgroundColor);
      const textColor = normalizeColorValue(option?.textColor);
      if (!backgroundColor && !textColor) return colors;

      return withActiveFromBase({
        ...colors,
        ...(backgroundColor
          ? { bg: backgroundColor, border: backgroundColor, dot: backgroundColor, activeBg: backgroundColor, activeBorder: backgroundColor }
          : {}),
        ...(textColor ? { text: textColor, activeText: textColor } : {}),
      });
    }

    function resolveOptionColors(option = {}, kind = "service") {
      const label =
        option.serviceName ||
        option.optionName ||
        option.typeName ||
        option.name ||
        option.providerType ||
        "";
      const styleKey = option.styleKey || inferStyleKey(label, kind);
      const defaults = getDefaultColorsByStyleKey(styleKey);
      const overrides = pickDefinedColors(option.colors);

      return mergeApiOptionColors(option, withActiveFromBase({ ...defaults, ...overrides }));
    }

    function applyOptionColors(el, colors) {
      if (!el || !colors) return;

      Object.entries(OPTION_COLOR_VAR_MAP).forEach(([key, cssVar]) => {
        if (colors[key]) {
          el.style.setProperty(cssVar, colors[key]);
        }
      });
    }

    function pickFilterChipActiveColors(colors) {
      if (!colors) return {};

      const activeBg = colors.activeBg || colors.bg;
      const activeText = colors.activeText || colors.text;
      const activeBorder = colors.activeBorder || colors.border || activeBg;
      const picked = {};

      if (activeBg) picked.activeBg = activeBg;
      if (activeText) picked.activeText = activeText;
      if (activeBorder) picked.activeBorder = activeBorder;

      return picked;
    }

    function applyFilterChipColors(el, colors) {
      applyOptionColors(el, pickFilterChipActiveColors(colors));
    }

    function buildOptionColorStyle(colors) {
      if (!colors) return "";

      const parts = Object.entries(OPTION_COLOR_VAR_MAP)
        .filter(([key]) => colors[key])
        .map(([key, cssVar]) => `${cssVar}:${colors[key]}`);

      return parts.length ? ` style="${parts.join(";")}"` : "";
    }

    function rebuildServiceOptionIndexes() {
      serviceOptionsById = new Map();
      serviceOptionsByNormalizedName = new Map();
      serviceNormalizedNameById = new Map();

      serviceOptions.forEach((item) => {
        const id = Number(item.id);
        if (Number.isNaN(id)) return;

        serviceOptionsById.set(id, item);
        const normalized = normalizeServiceName(item.serviceName);
        serviceNormalizedNameById.set(id, normalized);
        if (!serviceOptionsByNormalizedName.has(normalized)) {
          serviceOptionsByNormalizedName.set(normalized, item);
        }
      });
    }

    function getServiceOptionById(id) {
      const numericId = Number(id);
      if (Number.isNaN(numericId)) return undefined;
      return serviceOptionsById.get(numericId);
    }

    function getServiceOptionByName(name) {
      const target = normalizeServiceName(name);
      return serviceOptionsByNormalizedName.get(target);
    }

    function getServiceColors(serviceIdOrName, option) {
      if (option) return resolveOptionColors(option, "service");

      const resolvedOption =
        Number(serviceIdOrName) || /^\d+$/.test(String(serviceIdOrName))
          ? getServiceOptionById(serviceIdOrName)
          : getServiceOptionByName(serviceIdOrName);

      if (resolvedOption) return resolveOptionColors(resolvedOption, "service");
      return resolveOptionColors({ styleKey: inferStyleKey(serviceIdOrName, "service") }, "service");
    }

    function getServiceYellowBlackColors() {
      const yellow =
        getThemeVar("--primary") ||
        getThemeVar("--nim-service-mapping-bg") ||
        "#fedb1e";
      const black = getThemeVar("--text") || "#25282a";

      return { yellow, black };
    }

    function getServiceFilterChipColors() {
      const { yellow, black } = getServiceYellowBlackColors();
      return {
        activeBg: yellow,
        activeText: black,
        activeBorder: yellow,
      };
    }

    function getServiceTagColors() {
      const { yellow, black } = getServiceYellowBlackColors();
      return {
        bg: yellow,
        text: black,
        border: yellow,
      };
    }

    function rememberProviderTypeColorsFromProviders(providerList) {
      providerTypeColorsByName = new Map();

      providerList.forEach((provider) => {
        const typeName = String(provider?.providerType || "").trim();
        if (!typeName) return;

        const backgroundColor = normalizeColorValue(provider.providerTypeBackgroundColor);
        const textColor = normalizeColorValue(provider.providerTypeTextColor);
        if (!backgroundColor && !textColor) return;

        providerTypeColorsByName.set(typeName, { backgroundColor, textColor });
      });
    }

    function getFixedProviderTypeDotColor(typeName) {
      const styleKey = inferStyleKey(typeName, "provider");
      const defaults = getDefaultColorsByStyleKey(styleKey);
      return defaults.dot || getThemeVar("--text") || "#25282a";
    }

    function getProviderTypeFilterChipColors(typeName) {
      const colors = getProviderTypeColors(typeName);
      return { ...colors, dot: getFixedProviderTypeDotColor(typeName) };
    }

    function refreshProviderTypeFilterColors() {
      $$("[data-provider-type]").forEach((chip) => {
        applyOptionColors(chip, getProviderTypeFilterChipColors(chip.dataset.providerType));
      });
    }

    function getProviderTypeColors(typeName, option, provider) {
      if (provider?.providerTypeBackgroundColor || provider?.providerTypeTextColor) {
        return resolveOptionColors(
          {
            typeName: provider.providerType || typeName,
            backgroundColor: provider.providerTypeBackgroundColor,
            textColor: provider.providerTypeTextColor,
            styleKey: inferStyleKey(provider.providerType || typeName, "provider"),
          },
          "provider"
        );
      }

      const cached = providerTypeColorsByName.get(String(typeName || "").trim());
      if (cached) {
        return resolveOptionColors(
          { typeName, ...cached, styleKey: inferStyleKey(typeName, "provider") },
          "provider"
        );
      }

      if (option) return resolveOptionColors(option, "provider");
      return resolveOptionColors(
        { typeName, styleKey: inferStyleKey(typeName, "provider") },
        "provider"
      );
    }

    function findRepairSiteTypeOption(typeName) {
      const normalized = normalizeRepairSiteTypeName(typeName);
      return repairSiteOptions.find(
        (option) => normalizeRepairSiteTypeName(getRepairSiteTypeLabel(option)) === normalized
      );
    }

    function findRepairMethodOption(methodName) {
      const normalized = String(methodName || "").trim().toLowerCase();
      return repairMethodOptions.find(
        (option) => String(getRepairMethodLabel(option)).trim().toLowerCase() === normalized
      );
    }

    function getRepairMethodColors(methodName, option) {
      const resolvedOption = option || findRepairMethodOption(methodName);
      if (resolvedOption) {
        const colors = resolveOptionColors(
          { ...resolvedOption, serviceName: getRepairMethodLabel(resolvedOption) },
          "service"
        );
        return colors;
      }

      return getServiceTagColors();
    }

    function normalizeRepairSiteTypeName(typeName) {
      return String(typeName || "").trim().toLowerCase();
    }

    function getRepairSiteTypeStyleSlug(typeName) {
      const normalized = normalizeRepairSiteTypeName(typeName);
      if (normalized === "chicago warehouse") return "chicago-warehouse";
      if (normalized === "dealer") return "dealer";
      if (normalized === "independent technician") return "independent-technician";
      if (normalized === "repair centers") return "repair-centers";
      return "default";
    }

    function getRepairSiteTypeColors(typeName, option) {
      const resolvedOption = option || findRepairSiteTypeOption(typeName);
      if (resolvedOption) {
        const colors = resolveOptionColors(
          { ...resolvedOption, typeName: getRepairSiteTypeLabel(resolvedOption) },
          "provider"
        );
        return {
          ...colors,
          marker: markerColorFromOptionColors(colors, REPAIR_SITE_MARKER_FALLBACK_COLOR),
        };
      }

      const normalized = normalizeRepairSiteTypeName(typeName);
      const dealerColor = getThemeVar("--nim-dealer") || "#15803d";
      const technicianColor = getThemeVar("--nim-volunteer") || "#2050d8";
      const repairCenterColor = getThemeVar("--nim-repair-centers") || "#7c3aed";

      if (normalized === "chicago warehouse") {
        const color = REPAIR_SITE_MARKER_FALLBACK_COLOR;
        return {
          marker: color,
          dot: color,
          activeBg: "rgba(194, 65, 12, 0.1)",
          activeText: color,
          activeBorder: color,
        };
      }

      if (normalized === "dealer") {
        return {
          marker: dealerColor,
          dot: dealerColor,
          activeBg: "rgba(21, 128, 61, 0.1)",
          activeText: dealerColor,
          activeBorder: dealerColor,
        };
      }

      if (normalized === "independent technician") {
        return {
          marker: technicianColor,
          dot: technicianColor,
          activeBg: "rgba(32, 80, 216, 0.08)",
          activeText: technicianColor,
          activeBorder: technicianColor,
        };
      }

      if (normalized === "repair centers") {
        return {
          marker: repairCenterColor,
          dot: repairCenterColor,
          activeBg: "rgba(124, 58, 237, 0.1)",
          activeText: repairCenterColor,
          activeBorder: repairCenterColor,
        };
      }

      const fallback = REPAIR_SITE_MARKER_FALLBACK_COLOR;
      return {
        marker: fallback,
        dot: fallback,
        activeBg: "rgba(194, 65, 12, 0.1)",
        activeText: fallback,
        activeBorder: fallback,
      };
    }

    function getRepairSiteTypeFilterChipColors(typeName, option) {
      const colors = getRepairSiteTypeColors(typeName, option);
      return {
        ...colors,
        dot: markerColorFromOptionColors(colors, colors.dot || REPAIR_SITE_MARKER_FALLBACK_COLOR),
      };
    }

    function getRepairSiteMarkerColor() {
      // Unified marker color: same green as install markers (no longer derived from site type).
      return "#15803d";
    }

    function normalizeServiceName(value) {
      return String(value || "")
        .trim()
        .toLowerCase()
        .replace(/\s+/g, "")
        .replace(/\+/g, "+");
    }

    function renderServiceFilters() {
      const container = $("service-filters");
      if (!container) return;

      container.innerHTML = "";

      serviceOptions.forEach((service) => {
        const serviceId = Number(service.id);
        const isActive = selectedServiceIds.has(serviceId);
        const button = document.createElement("button");
        button.type = "button";
        button.className = `filter-chip filter-chip--option filter-chip--service${
          isActive ? " active" : ""
        }`;
        button.dataset.serviceId = String(serviceId);
        button.dataset.optionId = String(serviceId);
        button.textContent = service.serviceName;
        button.title = service.serviceName;
        applyFilterChipColors(button, getServiceColors(serviceId, service));
        button.addEventListener("click", () => toggleServiceFilter(serviceId));
        container.appendChild(button);
      });
    }

    function toggleProviderTypeFilter(type) {
        if (selectedProviderTypes.has(type)) {
          selectedProviderTypes.delete(type);
        } else {
          selectedProviderTypes.add(type);
        }

        $$("[data-provider-type]").forEach((chip) => {
          chip.classList.toggle("active", selectedProviderTypes.has(chip.dataset.providerType));
        });

      runWithFilterLoading(() => {
        applyFilters();
      });
    }

    function toggleServiceFilter(serviceId) {
      const id = Number(serviceId);
      if (Number.isNaN(id)) return;

        if (selectedServiceIds.has(id)) {
          selectedServiceIds.delete(id);
        } else {
          selectedServiceIds.add(id);
        }

      $$("[data-service-id]").forEach((chip) => {
        const chipId = Number(chip.dataset.serviceId);
        if (Number.isNaN(chipId)) return;
        chip.classList.toggle("active", selectedServiceIds.has(chipId));
      });

      runWithFilterLoading(() => {
        applyFilters();
      });
    }

    function providerHasService(provider, serviceId) {
      const id = Number(serviceId);
      if (Number.isNaN(id)) return false;

      if (
        Array.isArray(provider.serviceIds) &&
        provider.serviceIds.some((value) => Number(value) === id)
      ) {
        return true;
      }

      const targetName = serviceNormalizedNameById.get(id);
      if (!targetName) return false;

      return (provider.serviceItems || []).some(
        (item) => normalizeServiceName(item) === targetName
      );
    }

    function matchesProviderFilters(provider) {
      if (selectedProviderTypes.size > 0 && !selectedProviderTypes.has(provider.providerType)) {
        return false;
      }

      if (selectedServiceIds.size > 0) {
        const matchesAllSelected = [...selectedServiceIds].every((serviceId) =>
          providerHasService(provider, serviceId)
        );
        if (!matchesAllSelected) return false;
      }

      return true;
    }

    function getFilteredProviders() {
      return providers.filter((provider) => {
        if (!provider.lat || !provider.lng) return false;
        return matchesProviderFilters(provider);
      });
    }

    function usesViewportProviderMarkers() {
      if (hasActiveSearch) return false;
      return getFilteredProviders().length > MAX_VIEWPORT_MAP_MARKERS;
    }

    function usesViewportRepairMarkers() {
      if (hasActiveRepairSearch) return false;
      return getFilteredRepairSites().length > MAX_VIEWPORT_MAP_MARKERS;
    }

    function getBoundsCacheKey(bounds) {
      const ne = bounds.getNorthEast();
      const sw = bounds.getSouthWest();
      const zoom = map.getZoom();
      return [
        zoom,
        ne.lat().toFixed(2),
        ne.lng().toFixed(2),
        sw.lat().toFixed(2),
        sw.lng().toFixed(2),
      ].join(":");
    }

    function countMarkersOnMap(markerMap) {
      let count = 0;
      markerMap.forEach((marker) => {
        if (marker.map) count += 1;
      });
      return count;
    }

    function syncMapMarkersWithFilter() {
      if (!map) return;

      const filteredIds = new Set(
        getFilteredProviders().map((provider) => String(provider.id))
      );

      providerMarkers.forEach((marker, providerId) => {
        setMarkerMap(marker, filteredIds.has(String(providerId)) ? map : null);
      });
    }

    function scheduleViewportMarkerSync(force = false) {
      if (!usesViewportProviderMarkers() || !map) return;

      window.clearTimeout(viewportSyncTimer);
      viewportSyncTimer = window.setTimeout(() => {
        syncMapMarkersToViewport(force);
      }, MAP_VIEWPORT_SYNC_DEBOUNCE_MS);
    }

    function scheduleRepairViewportMarkerSync(force = false) {
      if (!usesViewportRepairMarkers() || !map) return;

      window.clearTimeout(repairViewportSyncTimer);
      repairViewportSyncTimer = window.setTimeout(() => {
        syncRepairMarkersToViewport(force);
      }, MAP_VIEWPORT_SYNC_DEBOUNCE_MS);
    }

    function getViewportSelectionRadiusMiles(zoom, datasetSize) {
      if (datasetSize <= LARGE_DATASET_THRESHOLD) return null;

      if (zoom <= 7) return 140;
      if (zoom <= 8) return 90;
      if (zoom <= 9) return 55;
      if (zoom <= 10) return 35;
      if (zoom <= 11) return 22;
      return 14;
    }

    function takeNearestMapItems(items, limit, centerLat, centerLng) {
      if (items.length <= limit) return items;

      let pool = items;
      const maxPool = limit * 8;
      if (pool.length > maxPool) {
        const step = Math.ceil(pool.length / maxPool);
        pool = pool.filter((_, index) => index % step === 0);
      }

      const scored = pool.map((item) => ({
        item,
        distance: haversineMiles(centerLat, centerLng, item.lat, item.lng),
      }));

      scored.sort((a, b) => a.distance - b.distance);
      return scored.slice(0, limit).map((entry) => entry.item);
    }

    function selectMapPointsForViewport(items, bounds, maxMarkers) {
      if (!items.length || !bounds || !map) return [];

      const center = map.getCenter();
      if (!center) return [];

      const centerLat = center.lat();
      const centerLng = center.lng();
      let candidates = items;

      const radiusMiles = getViewportSelectionRadiusMiles(map.getZoom(), items.length);
      if (radiusMiles != null) {
        candidates = items.filter(
          (item) => haversineMiles(centerLat, centerLng, item.lat, item.lng) <= radiusMiles
        );
      }

      candidates = candidates.filter((item) => bounds.contains({ lat: item.lat, lng: item.lng }));

      if (candidates.length <= maxMarkers) return candidates;

      return takeNearestMapItems(candidates, maxMarkers, centerLat, centerLng);
    }

    function syncMapMarkersToViewport(force = false) {
      if (!usesViewportProviderMarkers() || !map) return;

      const bounds = map.getBounds();
      if (!bounds) {
        google.maps.event.addListenerOnce(map, "idle", () => scheduleViewportMarkerSync(true));
        return;
      }

      const boundsKey = getBoundsCacheKey(bounds);
      if (!force && boundsKey === lastSyncedBoundsKey) return;
      lastSyncedBoundsKey = boundsKey;

      const filteredProviders = getFilteredProviders();
      const providersToShow = selectMapPointsForViewport(
        filteredProviders,
        bounds,
        MAX_VIEWPORT_MAP_MARKERS
      );

      const visibleIds = new Set(providersToShow.map((provider) => String(provider.id)));

      providersToShow.forEach((provider) => {
        ensureProviderMarker(provider);
        setMarkerMap(providerMarkers.get(provider.id), map);
      });

      providerMarkers.forEach((marker, providerId) => {
        if (visibleIds.has(String(providerId)) || String(providerId) === String(activeProviderId)) {
          return;
        }
        setMarkerMap(marker, null);
      });

      updateProviderCountLabel(filteredProviders);
    }

    function syncRepairMarkersToViewport(force = false) {
      if (!usesViewportRepairMarkers() || !map || !isRepairTabActive()) return;

      const bounds = map.getBounds();
      if (!bounds) {
        google.maps.event.addListenerOnce(map, "idle", () => scheduleRepairViewportMarkerSync(true));
        return;
      }

      const boundsKey = getBoundsCacheKey(bounds);
      if (!force && boundsKey === lastRepairSyncedBoundsKey) return;
      lastRepairSyncedBoundsKey = boundsKey;

      const filteredSites = getFilteredRepairSites();
      const sitesToShow = selectMapPointsForViewport(
        filteredSites,
        bounds,
        MAX_VIEWPORT_MAP_MARKERS
      );

      const visibleIds = new Set(sitesToShow.map((site) => String(site.id)));

      sitesToShow.forEach((site) => {
        ensureRepairSiteMarker(site);
        setMarkerMap(repairMarkers.get(site.id), map);
      });

      repairMarkers.forEach((marker, siteId) => {
        if (visibleIds.has(String(siteId)) || String(siteId) === String(activeRepairSiteId)) {
          return;
        }
        setMarkerMap(marker, null);
      });

      updateRepairSiteCountLabel(filteredSites);
    }

    function clearMapViewportListeners() {
      mapViewportListeners.forEach((listener) => google.maps.event.removeListener(listener));
      mapViewportListeners = [];
    }

    function bindMapViewportSync() {
      if (!map) return;

      clearMapViewportListeners();
      mapViewportListeners = [
        map.addListener("idle", () => {
          if (suppressViewportSyncEvents) return;

          if (isRepairTabActive()) {
            scheduleRepairViewportMarkerSync(false);
          } else {
            scheduleViewportMarkerSync(false);
          }
        }),
      ];
    }

    function getListCardId(card) {
      return card.dataset.providerId ?? card.dataset.repairSiteId ?? null;
    }

    function createChunkedListController(listEl, options) {
      const { getItemId, renderItem } = options;

      let items = [];
      let renderedCount = 0;
      let activeId = null;

      function syncActiveCardClass() {
        listEl.querySelectorAll(".provider-card").forEach((card) => {
          const cardId = getListCardId(card);
          card.classList.toggle("active", activeId != null && String(cardId) === String(activeId));
        });
      }

      function appendItems(fromIndex, toIndex) {
        const fragment = document.createDocumentFragment();
        for (let index = fromIndex; index < toIndex; index += 1) {
          const item = items[index];
          const itemId = getItemId(item);
          fragment.appendChild(renderItem(item, String(itemId) === String(activeId)));
        }
        listEl.appendChild(fragment);
      }

      function resetRenderedList(resetScroll = true) {
        listEl.replaceChildren();
        listEl.classList.add("provider-list--chunked");
        renderedCount = 0;

        if (!items.length) {
          listEl.classList.remove("provider-list--chunked");
          return;
        }

        const initialCount = Math.min(LIST_PAGE_SIZE, items.length);
        appendItems(0, initialCount);
        renderedCount = initialCount;

        if (resetScroll) {
          listEl.scrollTop = 0;
        }
      }

      function ensureRenderedUpToIndex(index) {
        if (index < 0 || index >= items.length) return;

        const targetCount = Math.min(
          Math.ceil((index + 1) / LIST_PAGE_SIZE) * LIST_PAGE_SIZE,
          items.length
        );

        if (targetCount <= renderedCount) return;

        appendItems(renderedCount, targetCount);
        renderedCount = targetCount;
      }

      function maybeLoadMore() {
        if (renderedCount >= items.length) return;

        const distanceToBottom =
          listEl.scrollHeight - listEl.scrollTop - listEl.clientHeight;
        if (distanceToBottom > LIST_SCROLL_LOAD_THRESHOLD_PX) return;

        const nextCount = Math.min(renderedCount + LIST_PAGE_SIZE, items.length);
        appendItems(renderedCount, nextCount);
        renderedCount = nextCount;
      }

      function onScroll() {
        maybeLoadMore();
      }

      listEl.addEventListener("scroll", onScroll, { passive: true });

      return {
        setItems(newItems, { resetScroll } = {}) {
          const previousLength = items.length;
          items = Array.isArray(newItems) ? newItems : [];

          const shouldResetScroll =
            resetScroll === true ||
            (resetScroll !== false && previousLength !== items.length);

          resetRenderedList(shouldResetScroll);
          syncActiveCardClass();
        },
        setActiveId(id) {
          activeId = id == null ? null : id;
          syncActiveCardClass();
        },
        scrollToId(id) {
          if (id == null) return;
          const index = items.findIndex((item) => String(getItemId(item)) === String(id));
          if (index < 0) return;

          ensureRenderedUpToIndex(index);
          const card = listEl.querySelector(
            `.provider-card[data-provider-id="${CSS.escape(String(id))}"], .provider-card[data-repair-site-id="${CSS.escape(String(id))}"]`
          );
          card?.scrollIntoView({ block: "nearest" });
        },
        destroy() {
          listEl.removeEventListener("scroll", onScroll);
          listEl.replaceChildren();
          listEl.classList.remove("provider-list--chunked");
          items = [];
          renderedCount = 0;
          activeId = null;
        },
      };
    }

    function getProviderVirtualList() {
      const listEl = $("provider-list");
      if (!listEl) return null;

      if (!providerVirtualList) {
        providerVirtualList = createChunkedListController(listEl, {
          getItemId: (provider) => provider.id,
          renderItem: (provider, isActive) => buildProviderCardElement(provider, isActive),
        });
      }

      return providerVirtualList;
    }

    function getRepairVirtualList() {
      const listEl = $("repair-site-list");
      if (!listEl) return null;

      if (!repairVirtualList) {
        repairVirtualList = createChunkedListController(listEl, {
          getItemId: (site) => site.id,
          renderItem: (site, isActive) => buildRepairSiteCardElement(site, isActive),
        });
      }

      return repairVirtualList;
    }

    function buildProviderCardElement(provider, isActive = false) {
      const card = document.createElement("button");
      card.type = "button";
      const isSheetSelected =
        isMobileFilterSheetOpen() &&
        String(mobileSheetSelectedProviderId) === String(provider.id);
      card.className = `provider-card${isActive ? " active" : ""}${
        isSheetSelected ? " mobile-sheet-selected" : ""
      }`;
      card.dataset.providerId = provider.id;

      const servicesSectionHtml = buildProviderServicesSectionHtml(provider);
      const addressSectionHtml = buildProviderAddressSectionHtml(provider);

      card.innerHTML = `
        <div class="provider-card-layout">
          <div class="provider-card-main">
            <div class="provider-card-header">
              <div class="provider-name">${escapeHtml(getProviderName(provider))}</div>
            </div>
            ${servicesSectionHtml}
            ${addressSectionHtml}
          </div>
        </div>
      `;

      card.addEventListener("click", () => {
        if (isMobileNimUi() && isMobileFilterSheetOpen()) {
          setMobileSheetSelectedProvider(provider.id);
          return;
        }
        focusProvider(provider);
      });
      return card;
    }

    function buildRepairSiteCardElement(site, isActive = false) {
      const card = document.createElement("button");
      card.type = "button";
      const isSheetSelected =
        isMobileFilterSheetOpen() &&
        String(mobileSheetSelectedRepairSiteId) === String(site.id);
      card.className = `provider-card${isActive ? " active" : ""}${
        isSheetSelected ? " mobile-sheet-selected" : ""
      }`;
      card.dataset.repairSiteId = site.id;
      card.innerHTML = `
        <div class="provider-card-layout">
          <div class="provider-card-main">
            <div class="provider-card-header">
              <div class="provider-name">${escapeHtml(getRepairSiteName(site))}</div>
            </div>
            ${buildRepairMethodsSectionHtml(site)}
            ${buildRepairSiteMetaSectionHtml(site)}
            ${buildRepairSiteAddressSectionHtml(site)}
          </div>
        </div>
      `;
      card.addEventListener("click", () => {
        if (isMobileNimUi() && isMobileFilterSheetOpen()) {
          setMobileSheetSelectedRepairSite(site.id);
          return;
        }
        focusRepairSite(site);
      });
      return card;
    }

    function setActiveProviderCard(providerId) {
      const virtualList = providerVirtualList;
      if (virtualList) {
        virtualList.setActiveId(providerId);
        if (providerId != null) {
          virtualList.scrollToId(providerId);
        }
        return;
      }

      const listEl = $("provider-list");
      if (!listEl) return;

      listEl.querySelectorAll(".provider-card.active").forEach((card) => {
        card.classList.remove("active");
      });

      if (providerId == null) return;

      const card = listEl.querySelector(
        `.provider-card[data-provider-id="${CSS.escape(String(providerId))}"]`
      );
      card?.classList.add("active");
    }

    function applyFilters() {
      renderProviderList();

      if (usesViewportProviderMarkers()) {
        lastSyncedBoundsKey = "";
        scheduleViewportMarkerSync(true);
        return;
      }

        syncMapMarkersWithFilter();
    }

    async function loadServiceOptions() {
      try {
        serviceOptions = await fetchServiceOptions();
        rebuildServiceOptionIndexes();
        renderServiceFilters();
      } catch (error) {
        console.error("Failed to load service options:", error);
      }
    }

    function initFilterControls() {
      $$("[data-provider-type]").forEach((chip) => {
        chip.classList.add("filter-chip--option");
        applyOptionColors(chip, getProviderTypeFilterChipColors(chip.dataset.providerType));
        chip.addEventListener("click", () => toggleProviderTypeFilter(chip.dataset.providerType));
      });
    }

    function isInstallTabActive() {
      return activeTab === "install";
    }

    function isRepairTabActive() {
      return activeTab === "repair";
    }

    function updateSearchPlaceholder() {
      if (!placeAutocomplete) return;

      const placeholder = SEARCH_PLACEHOLDER;
      if (placeAutocomplete.placeholder !== undefined) {
        placeAutocomplete.placeholder = placeholder;
      }

      const input = placeAutocomplete.querySelector?.("input");
      if (input) input.placeholder = placeholder;
    }

    function updateTabPanels() {
      $$("[data-tab]").forEach((button) => {
        const isActive = button.dataset.tab === activeTab;
        button.classList.toggle("is-active", isActive);
        button.setAttribute("aria-selected", isActive ? "true" : "false");
      });

      $$("[data-tab-panel]").forEach((panel) => {
        panel.hidden = panel.dataset.tabPanel !== activeTab;
      });

      updateSearchPlaceholder();
    }

    function hideMarkersForTab(tabName) {
      if (tabName === "install") {
        providerMarkers.forEach((marker) => setMarkerMap(marker, null));
        return;
      }

      repairMarkers.forEach((marker) => setMarkerMap(marker, null));
    }

    function showMarkersForTab(tabName) {
      if (!map) return;

      if (userMarker && currentLocation) {
        setMarkerMap(userMarker, map);
      }

      if (tabName === "install") {
        if (usesViewportProviderMarkers()) {
          lastSyncedBoundsKey = "";
          scheduleViewportMarkerSync(true);
        } else {
        syncMapMarkersWithFilter();
        }
        return;
      }

      if (usesViewportRepairMarkers()) {
        lastRepairSyncedBoundsKey = "";
        scheduleRepairViewportMarkerSync(true);
      } else {
      syncRepairMapMarkersWithFilter();
    }
    }

    async function ensureRepairSitesLoaded(force = false) {
      if (repairSitesLoading) return;

      const searchParams = hasActiveRepairSearch
        ? {
            keyword: "",
            address: lastRepairSearchAddress || currentAddress || null,
            placeId: lastRepairSearchPlaceId,
          }
        : null;
      const cacheKey = getRepairSearchCacheKey(searchParams);
      if (repairSitesLoaded && !force && lastRepairSearchCacheKey === cacheKey) return;

      await loadRepairSites(searchParams, { force });
    }

    async function loadRepairFilterOptions() {
      if (repairFilterOptionsLoading || repairFilterOptionsLoaded) return;

      repairFilterOptionsLoading = true;
      try {
        const [siteTypes, methods] = await Promise.all([
          fetchRepairSiteTypeOptions(),
          fetchRepairMethodOptions(),
        ]);
        repairSiteOptions = siteTypes;
        repairMethodOptions = methods;
        repairFilterOptionsLoaded = true;
        renderRepairSiteTypeFilters();
        renderRepairServiceFilters();
      } catch (error) {
        console.error("Failed to load repair filter options:", error);
      } finally {
        repairFilterOptionsLoading = false;
      }
    }

    async function ensureRepairFilterOptionsLoaded() {
      if (repairFilterOptionsLoaded || repairFilterOptionsLoading) return;
      await loadRepairFilterOptions();
    }

    async function switchTab(nextTab) {
      if (!nextTab || nextTab === activeTab || tabSwitchInProgress) return;

      hidePredictionsDropdown();
      closeProviderInfoWindow();
      activeProviderId = null;
      activeRepairSiteId = null;
      setActiveProviderCard(null);
      setActiveRepairSiteCard(null);

      hideMarkersForTab(activeTab);
      activeTab = nextTab;
      updateTabPanels();
      mobileSheetSelectedProviderId = null;
      mobileSheetSelectedRepairSiteId = null;
      updateMobileToolbarCount();

      clearFilterLoadingTimer();
      tabSwitchInProgress = true;
      setTabsDisabled(true);

      const loadingMessage = isRepairTabActive()
        ? "Loading repair sites…"
        : "Loading providers…";
      setTabSwitchLoading(true, activeTab, loadingMessage);
      const startedAt = Date.now();

      try {
        if (isRepairTabActive()) {
          await ensureRepairFilterOptionsLoaded();
          if (hasActiveSearch && currentAddress) {
            await showRepairSitesByAddress(currentAddress, lastSearchPlaceId);
          } else {
            await ensureRepairSitesLoaded();
          }
        } else if (hasActiveRepairSearch && currentAddress) {
          await showNearbyProviders(currentAddress, lastRepairSearchPlaceId);
        }

        showMarkersForTab(activeTab);
        noteMapInteraction();
      } catch (error) {
        console.error("NearbyInstallersMap tab switch failed:", error);
        setStatus(
          error.message ||
            (isRepairTabActive()
              ? "Failed to load repair sites"
              : "Failed to load providers"),
          true
        );
      } finally {
        tabSwitchInProgress = false;
        await waitForMinimumLoadingDuration(startedAt);
        setTabSwitchLoading(false, activeTab);
        setTabsDisabled(false);
      }
    }

    function initTabControls() {
      $$("[data-tab]").forEach((button) => {
        button.addEventListener("click", () => {
          const nextTab = button.dataset.tab;
          if (!nextTab || nextTab === activeTab) return;
          switchTab(nextTab);
        });
      });

      updateTabPanels();
    }

    function getRepairSiteTypeLabel(option) {
      if (typeof option === "string") return option.trim();
      return String(
        option.optionName || option.typeName || option.siteTypeName || option.name || option.siteType || ""
      ).trim();
    }

    function getRepairMethodLabel(option) {
      if (typeof option === "string") return option.trim();
      return String(
        option.optionName || option.methodName || option.serviceName || option.name || ""
      ).trim();
    }

    function getRepairSiteTypeDetailEntries(site) {
      if (Array.isArray(site?.siteTypeDetails) && site.siteTypeDetails.length) {
        return site.siteTypeDetails
          .map((detail) => ({
            id: detail.id ?? null,
            optionName: String(detail.optionName || "").trim(),
            backgroundColor: detail.backgroundColor ?? null,
            textColor: detail.textColor ?? null,
          }))
          .filter((detail) => detail.optionName);
      }

      return getRepairSiteTypes(site).map((optionName) => ({
        id: null,
        optionName,
        backgroundColor: null,
        textColor: null,
      }));
    }

    function getRepairMethodDetailEntries(site) {
      if (Array.isArray(site?.repairMethodDetails) && site.repairMethodDetails.length) {
        return site.repairMethodDetails
          .map((detail) => ({
            id: detail.id ?? null,
            optionName: String(detail.optionName || "").trim(),
            backgroundColor: detail.backgroundColor ?? null,
            textColor: detail.textColor ?? null,
          }))
          .filter((detail) => detail.optionName);
      }

      return getRepairSiteMethods(site).map((optionName) => ({
        id: null,
        optionName,
        backgroundColor: null,
        textColor: null,
      }));
    }

    function getRepairSiteTypes(site) {
      if (Array.isArray(site?.siteType)) {
        return site.siteType.map((item) => String(item).trim()).filter(Boolean);
      }

      const legacyValue = String(site?.siteType || "").trim();
      return legacyValue ? [legacyValue] : [];
    }

    function getRepairSiteMethods(site) {
      if (Array.isArray(site?.repairMethods)) {
        return site.repairMethods.map((item) => String(item).trim()).filter(Boolean);
      }

      return String(site?.repairMethods || "")
        .split(/[,;|]/)
        .map((item) => item.trim())
        .filter(Boolean);
    }

    function initRepairFilterControls() {
      renderRepairSiteTypeFilters();
      renderRepairServiceFilters();
    }

    function renderRepairSiteTypeFilters() {
      const container = $("repair-site-type-filters");
      if (!container) return;

      container.innerHTML = "";
      if (!repairSiteOptions.length) return;

      repairSiteOptions.forEach((option) => {
        const typeName = getRepairSiteTypeLabel(option);
        if (!typeName) return;

        const button = document.createElement("button");
        button.type = "button";
        button.className = `filter-chip filter-chip--option filter-chip--repair-site-type${
          selectedRepairSiteTypes.has(typeName) ? " active" : ""
        }`;
        button.dataset.repairSiteType = typeName;
        button.title = typeName;

        const dot = document.createElement("span");
        dot.className = "filter-chip-dot";
        dot.setAttribute("aria-hidden", "true");

        const label = document.createElement("span");
        label.textContent = typeName;

        button.appendChild(dot);
        button.appendChild(label);
        applyOptionColors(button, getRepairSiteTypeFilterChipColors(typeName, option));
        button.addEventListener("click", () => toggleRepairSiteTypeFilter(typeName));
        container.appendChild(button);
      });
    }

    function renderRepairServiceFilters() {
      const container = $("repair-service-filters");
      if (!container) return;

      container.innerHTML = "";
      if (!repairMethodOptions.length) return;

      repairMethodOptions.forEach((method) => {
        const methodLabel = getRepairMethodLabel(method);
        if (!methodLabel) return;

        const button = document.createElement("button");
        button.type = "button";
        button.className = `filter-chip filter-chip--option filter-chip--service filter-chip--repair-service${
          selectedRepairMethods.has(methodLabel) ? " active" : ""
        }`;
        button.dataset.repairMethod = methodLabel;
        button.textContent = methodLabel;
        button.title = methodLabel;
        applyFilterChipColors(button, getRepairMethodColors(methodLabel, method));
        button.addEventListener("click", () => toggleRepairMethodFilter(methodLabel));
        container.appendChild(button);
      });
    }

    function toggleRepairSiteTypeFilter(typeName) {
      const normalized = String(typeName || "").trim();
      if (!normalized) return;

          if (selectedRepairSiteTypes.has(normalized)) {
            selectedRepairSiteTypes.delete(normalized);
          } else {
            selectedRepairSiteTypes.add(normalized);
          }

      $$("[data-repair-site-type]").forEach((chip) => {
        chip.classList.toggle("active", selectedRepairSiteTypes.has(chip.dataset.repairSiteType));
      });

      runWithFilterLoading(() => {
          applyRepairFilters();
      }, { repair: true });
    }

    function toggleRepairMethodFilter(methodName) {
      const normalized = String(methodName || "").trim();
      if (!normalized) return;

          if (selectedRepairMethods.has(normalized)) {
            selectedRepairMethods.delete(normalized);
          } else {
            selectedRepairMethods.add(normalized);
          }

      $$("[data-repair-method]").forEach((chip) => {
        chip.classList.toggle("active", selectedRepairMethods.has(chip.dataset.repairMethod));
      });

      runWithFilterLoading(() => {
          applyRepairFilters();
      }, { repair: true });
    }

    function repairSiteHasMethod(site, methodName) {
      const targetName = String(methodName || "").trim();
      if (!targetName) return false;

      const normalizedTarget = normalizeServiceName(targetName);
      return getRepairSiteMethods(site).some(
        (item) => item === targetName || normalizeServiceName(item) === normalizedTarget
      );
    }

    function matchesRepairSiteFilters(site) {
      if (selectedRepairSiteTypes.size > 0) {
        const siteTypes = getRepairSiteTypes(site);
        if (!siteTypes.length) return false;

        const matchesSelectedType = siteTypes.some((siteType) =>
          [...selectedRepairSiteTypes].some(
            (selectedType) => selectedType.toLowerCase() === siteType.toLowerCase()
          )
        );
        if (!matchesSelectedType) return false;
      }

      if (selectedRepairMethods.size > 0) {
        const matchesAllSelected = [...selectedRepairMethods].every((methodName) =>
          repairSiteHasMethod(site, methodName)
        );
        if (!matchesAllSelected) return false;
      }

      return true;
    }

    function getFilteredRepairSites() {
      return repairSites.filter((site) => {
        if (!site.lat || !site.lng) return false;
        return matchesRepairSiteFilters(site);
      });
    }

    function applyRepairFilters() {
      renderRepairSiteList();

      if (usesViewportRepairMarkers()) {
        lastRepairSyncedBoundsKey = "";
        scheduleRepairViewportMarkerSync(true);
        return;
      }

        syncRepairMapMarkersWithFilter();
    }

    function setActiveRepairSiteCard(siteId) {
      const virtualList = repairVirtualList;
      if (virtualList) {
        virtualList.setActiveId(siteId);
        if (siteId != null) {
          virtualList.scrollToId(siteId);
        }
        return;
      }

      const listEl = $("repair-site-list");
      if (!listEl) return;

      listEl.querySelectorAll(".provider-card.active").forEach((card) => {
        card.classList.remove("active");
      });

      if (siteId == null) return;

      const card = listEl.querySelector(
        `.provider-card[data-repair-site-id="${CSS.escape(String(siteId))}"]`
      );
      card?.classList.add("active");
    }

    function getRepairSiteName(site) {
      return site.companyName || "Unknown Repair Site";
    }

    function buildRepairMethodsSectionHtml(site) {
      const methods = getRepairMethodDetailEntries(site);
      if (!methods.length) return "";

      const offerServiceLabel = escapeHtml(config.offerServiceLabel || "Offer Service");
      const methodTagsHtml = methods
        .map((method) => {
          const colors = getRepairMethodColors(method.optionName, method);
          return `<span class="provider-service-tag provider-service-tag--option"${buildOptionColorStyle(
            colors
          )}>${escapeHtml(method.optionName)}</span>`;
        })
        .join("");

      return `
        <div class="provider-services">
          <div class="provider-services-label">${offerServiceLabel}</div>
          <div class="provider-service-tags">${methodTagsHtml}</div>
        </div>
      `;
    }

    function buildRepairSiteMetaSectionHtml(site) {
      const lines = [];

      if (site.businessHours) {
        lines.push(
          `<div class="repair-site-meta"><span class="repair-site-meta-label">Business Hours:</span> ${escapeHtml(site.businessHours)}</div>`
        );
      }

      return lines.join("");
    }

    function buildRepairSiteAddressSectionHtml(site) {
      const address = normalizeAddress(site.formattedAddress || "");
      if (!address) return "";

      return `<div class="provider-address"><div class="provider-address-line">${escapeHtml(address)}</div></div>`;
    }

    function buildRepairSiteInfoWindowHtml(site) {
      const name = escapeHtml(getRepairSiteName(site));
      const methodsSectionHtml = buildRepairMethodsSectionHtml(site);
      const metaSectionHtml = buildRepairSiteMetaSectionHtml(site);
      const addressSectionHtml = buildRepairSiteAddressSectionHtml(site);
      const contactItems = [];

      if (site.contactName) {
        contactItems.push(`
          <div class="nim-info-window__contact-item">
            <span class="nim-info-window__contact-text">${escapeHtml(site.contactName)}</span>
          </div>
        `);
      }

      if (site.phoneNumber) {
        const phoneRaw = String(site.phoneNumber).trim();
        contactItems.push(`
          <a class="nim-info-window__contact-item" href="tel:${encodeURIComponent(phoneRaw)}">
            <span class="nim-info-window__contact-icon" aria-hidden="true">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.12.86.3 1.7.54 2.5a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.58-1.11a2 2 0 0 1 2.11-.45c.8.24 1.64.42 2.5.54A2 2 0 0 1 22 16.92z"></path>
              </svg>
            </span>
            <span class="nim-info-window__contact-text">${escapeHtml(phoneRaw)}</span>
          </a>
        `);
      }

      if (site.email) {
        const emailRaw = String(site.email).trim();
        contactItems.push(`
          <a class="nim-info-window__contact-item" href="mailto:${encodeURIComponent(emailRaw)}">
            <span class="nim-info-window__contact-icon" aria-hidden="true">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="2" y="4" width="20" height="16" rx="2"></rect>
                <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
              </svg>
            </span>
            <span class="nim-info-window__contact-text">${escapeHtml(emailRaw)}</span>
          </a>
        `);
      }

      return `
        <div class="nim-info-window nim-info-window--repair">
          <button type="button" class="nim-info-window__close" aria-label="Close">&times;</button>
          <div class="nim-info-window__head">
            <div class="nim-info-window__title-row">
              <h3 class="nim-info-window__title">${name}</h3>
            </div>
          </div>
          <div class="nim-info-window__body">
            ${methodsSectionHtml}
            ${metaSectionHtml}
            ${addressSectionHtml}
            ${contactItems.length ? `<div class="nim-info-window__contact">${contactItems.join("")}</div>` : ""}
          </div>
        </div>
      `;
    }

    function updateRepairSiteCountLabel(filteredSites = null) {
      const countEl = $("repair-site-count");
      if (!countEl) return;

      if (!repairSites.length) {
        lastRepairSiteCountText = "";
        countEl.textContent = "";
        return;
      }

      const sitesForCount = filteredSites || getFilteredRepairSites();
      let visibleMarkerCount = 0;
      repairMarkers.forEach((marker) => {
        if (marker.map) visibleMarkerCount += 1;
      });

      const hasFilters = selectedRepairSiteTypes.size > 0 || selectedRepairMethods.size > 0;
      let nextText = "";
      if (hasFilters) {
        nextText = `${sitesForCount.length} shown`;
      } else if (visibleMarkerCount > 0) {
        nextText = `${visibleMarkerCount} on map · ${repairSites.length} total`;
      } else {
        nextText = `${repairSites.length} total`;
      }

      if (nextText === lastRepairSiteCountText) return;
      lastRepairSiteCountText = nextText;
      countEl.textContent = nextText;
      updateMobileToolbarCount();
    }

    function renderRepairSiteList() {
      const listEl = $("repair-site-list");
      const countEl = $("repair-site-count");
      if (!listEl) return;

      if (!repairSites.length) {
        lastRepairSiteCountText = "";
        if (countEl) countEl.textContent = "";
        listEl.classList.remove("provider-list--chunked");
        listEl.innerHTML = repairListEmptyMessage
          ? `<div class="list-placeholder"><p>${escapeHtml(repairListEmptyMessage)}</p></div>`
          : "";
        return;
      }

      const filteredSites = getFilteredRepairSites();
      updateRepairSiteCountLabel(filteredSites);

      if (!filteredSites.length) {
        listEl.classList.remove("provider-list--chunked");
        listEl.innerHTML = `<div class="list-placeholder"><p>No repair sites match your filters.</p></div>`;
        return;
      }

      const virtualList = getRepairVirtualList();
      virtualList.setActiveId(isMobileFilterSheetOpen() ? null : activeRepairSiteId);
      virtualList.setItems(filteredSites);
    }

    function applyRepairSiteCoordinates(site) {
      const coords = getProviderLatLng(site);
      if (!coords) return false;

      site.lat = coords.lat;
      site.lng = coords.lng;
      return true;
    }

    function normalizeRepairSearchParams(searchParams) {
      if (searchParams == null) {
        return { keyword: "", address: null, placeId: null };
      }

      const keyword = String(searchParams.keyword ?? "").trim();
      const address = String(searchParams.address ?? "").trim();
      const placeId = String(searchParams.placeId ?? "").trim();

      return {
        keyword,
        address: address || null,
        placeId: placeId && address ? placeId : null,
      };
    }

    function getRepairSearchCacheKey(searchParams) {
      return JSON.stringify(normalizeRepairSearchParams(searchParams));
    }

    async function fetchRepairSites(searchParams) {
      const { keyword, address, placeId } = normalizeRepairSearchParams(searchParams);
      const payload = {};

      if (keyword) payload.keyword = keyword;
      if (address) payload.address = address;
      if (placeId) payload.placeId = placeId;

      const response = await fetch(REPAIR_SITE_LIST_API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`API returned ${response.status}`);
      }

      const result = await response.json();
      if (result.code !== 200) {
        throw new Error(result.msg || "Failed to load repair sites");
      }

      return Array.isArray(result.data) ? result.data : [];
    }

    function clearRepairMarkers() {
      repairMarkers.forEach((marker) => destroyProviderMarker(marker));
      repairMarkers.clear();
    }

    function addSingleRepairSiteMarker(site) {
      if (!site.lat || !site.lng || repairMarkers.has(site.id)) return;

      const pin = new PinElement({
        background: getRepairSiteMarkerColor(),
        borderColor: "#ffffff",
        glyphColor: "#ffffff",
      });

      const marker = new AdvancedMarkerElement({
        map,
        position: { lat: site.lat, lng: site.lng },
        title: getRepairSiteName(site),
        content: pin.element,
      });

      marker.addListener("click", () => focusRepairSite(site, false));
      repairMarkers.set(site.id, marker);
    }

    function ensureRepairSiteMarker(site) {
      if (!site?.lat || !site?.lng) return null;

      if (!repairMarkers.has(site.id)) {
        addSingleRepairSiteMarker(site);
      } else {
        setMarkerMap(repairMarkers.get(site.id), map);
      }

      return repairMarkers.get(site.id) || null;
    }

    function fitMapToRepairMarkers(siteList) {
      const bounds = new google.maps.LatLngBounds();
      let hasPoint = false;

      siteList.forEach((site) => {
        if (site.lat && site.lng) {
          bounds.extend({ lat: site.lat, lng: site.lng });
          hasPoint = true;
        }
      });

      if (currentLocation) {
        bounds.extend(currentLocation);
        hasPoint = true;
      }

      if (hasPoint) {
        runWithSuppressedViewportSync(() => {
          map.fitBounds(bounds, 64);
        });
      }
    }

    function syncRepairMapMarkersWithFilter() {
      if (!map) return;

      const filteredIds = new Set(
        getFilteredRepairSites().map((site) => String(site.id))
      );

      repairMarkers.forEach((marker, siteId) => {
        setMarkerMap(marker, filteredIds.has(String(siteId)) ? map : null);
      });
    }

    function openMapInfoWindow(content, anchor) {
      if (!infoWindow || !anchor || !map) return;

      suppressInfoWindowCloseSelectionReset = true;
      syncInfoWindowLayoutVars();
      infoWindow.setContent(content);
      infoWindow.open({ map, anchor });

      google.maps.event.addListenerOnce(infoWindow, "domready", () => {
        suppressInfoWindowCloseSelectionReset = false;

        if (isRepairTabActive() && activeRepairSiteId != null) {
          setActiveRepairSiteCard(activeRepairSiteId);
        } else if (!isRepairTabActive() && activeProviderId != null) {
          setActiveProviderCard(activeProviderId);
        }
      });
    }

    function openRepairSiteInfoWindow(site) {
      if (!isRepairTabActive() || !site) return;

      const marker = repairMarkers.get(site.id);
      if (!marker) return;

      openMapInfoWindow(buildRepairSiteInfoWindowHtml(site), marker);
    }

    function focusRepairSite(site, shouldPan = true) {
      if (!site?.lat || !site?.lng) return;

      activeRepairSiteId = site.id;
      setActiveRepairSiteCard(site.id);
      ensureRepairSiteMarker(site);

      if (shouldPan) {
        runWithSuppressedViewportSync(() => {
          map.panTo({ lat: site.lat, lng: site.lng });
          map.setZoom(Math.max(map.getZoom(), FOCUS_MAP_ZOOM));
        });
        google.maps.event.addListenerOnce(map, "idle", () => {
          if (usesViewportRepairMarkers()) {
            scheduleRepairViewportMarkerSync(true);
          }
          openRepairSiteInfoWindow(site);
        });
      } else {
        openRepairSiteInfoWindow(site);
      }
    }

    async function prepareRepairSites(siteList, options = {}) {
      const { shouldFitMap = true } = options;

      repairSites = siteList.filter((site) => applyRepairSiteCoordinates(site));

      activeRepairSiteId = null;
      setActiveRepairSiteCard(null);
      closeProviderInfoWindow();
      clearRepairMarkers();
      repairListEmptyMessage = repairSites.length ? "" : "No repair sites found";

      if (usesViewportRepairMarkers()) {
        applyRepairFilters();
        if (shouldFitMap) {
          applyInitialMapView();
        }
        scheduleRepairViewportMarkerSync(true);
        return repairSites;
      }

      getFilteredRepairSites()
        .slice(0, MAX_SEARCH_MODE_MAP_MARKERS)
        .forEach((site) => addSingleRepairSiteMarker(site));
      applyRepairFilters();

      const markersToFit = getFilteredRepairSites().slice(0, MAX_SEARCH_MODE_MAP_MARKERS);
      if (shouldFitMap && markersToFit.length) {
        fitMapToRepairMarkers(markersToFit);
      }

      return repairSites;
    }

    async function loadRepairSitesFromApi(searchParams, loadingMessage) {
      if (isRepairTabActive() && !tabSwitchInProgress) {
        setRepairListLoading(true, loadingMessage);
      }

      try {
        const sites = await fetchRepairSites(searchParams);
        activeRepairSiteId = null;
        setActiveRepairSiteCard(null);
        closeProviderInfoWindow();

        repairListEmptyMessage = "";
        const mappedSites = await prepareRepairSites(sites, {
          shouldFitMap: true,
        });

        if (hasActiveRepairSearch && !mappedSites.length) {
          repairListEmptyMessage = sites.length
            ? "No repair sites with map coordinates found"
            : "No repair sites found within 90 miles of this address";
          renderRepairSiteList();
        } else {
          repairListEmptyMessage = "";
        }

        if (isRepairTabActive()) {
          setStatus("");
        }

        return mappedSites;
      } catch (error) {
        if (isRepairTabActive()) {
          setStatus(error.message || "Failed to load repair sites", true);
        }
        console.error(error);
        throw error;
      } finally {
        if (isRepairTabActive() && !tabSwitchInProgress) {
          setRepairListLoading(false);
        }
      }
    }

    async function loadRepairSites(searchParams, options = {}) {
      const { force = false } = options;
      const cacheKey = getRepairSearchCacheKey(searchParams);
      const params = normalizeRepairSearchParams(searchParams);

      if (repairSitesLoading) return repairSites;
      if (repairSitesLoaded && !force && lastRepairSearchCacheKey === cacheKey) return repairSites;

      repairSitesLoading = true;
      const loadingMessage = params.address || params.keyword
        ? "Searching repair sites…"
        : "Loading repair sites…";

      try {
        lastRepairSearchCacheKey = cacheKey;
        repairSitesLoaded = true;
        return await loadRepairSitesFromApi(params, loadingMessage);
      } catch (error) {
        repairListEmptyMessage = error.message || "Failed to load repair sites";
        repairSites = [];
        clearRepairMarkers();
        renderRepairSiteList();
        throw error;
      } finally {
        repairSitesLoading = false;
      }
    }

    function resetRepairFilters() {
      selectedRepairSiteTypes.clear();
      selectedRepairMethods.clear();
      renderRepairSiteTypeFilters();
      renderRepairServiceFilters();
    }

    async function viewAllRepairSites() {
      hidePredictionsDropdown();
      setStatus("");
      resetSearchInput();
      resetRepairFilters();

      hasActiveRepairSearch = false;
      lastRepairSearchCacheKey = null;
      lastRepairSearchAddress = null;
      lastRepairSearchPlaceId = null;
      repairListEmptyMessage = "";
      clearUserLocationMarker();

      await loadRepairSites(null, { force: true });
    }

    async function showRepairSitesByAddress(address, placeId = null) {
      hasActiveRepairSearch = true;
      const normalizedAddress = String(address || "").trim();
      lastRepairSearchAddress = normalizedAddress || null;
      lastRepairSearchPlaceId = placeId || null;

      return loadRepairSites(
        {
          keyword: "",
          address: normalizedAddress || null,
          placeId: placeId || null,
        },
        { force: true }
      );
    }

    function syncSearchInputHeight(element = placeAutocomplete) {
      if (!element || element.tagName !== "TEXTAREA") return;

      const maxHeight = 96;
      element.style.height = "auto";
      const scrollHeight = element.scrollHeight;
      element.style.height = `${Math.min(scrollHeight, maxHeight)}px`;
      element.style.overflowY = scrollHeight > maxHeight ? "auto" : "hidden";
    }

    function mountSearchInput() {
      const input = document.createElement("textarea");
      input.className = "nim-fallback-input";
      input.id = "search-input-" + sectionId;
      input.placeholder = SEARCH_PLACEHOLDER;
      input.setAttribute("autocomplete", "off");
      input.rows = 1;
      input.setAttribute("aria-multiline", "true");
      $(".nim-autocomplete-container").appendChild(input);
      placeAutocomplete = input;

      attachSearchInputListeners(input);

      input.addEventListener("input", () => {
        syncSearchInputHeight(input);
      });

      input.addEventListener("keydown", (event) => {
        if (event.key === "Enter" && !event.shiftKey) {
          event.preventDefault();
          handleSearchClick();
        }
      });

      window.requestAnimationFrame(() => {
        syncSearchInputHeight(input);
      });
    }

    async function ensurePlacesLibrary() {
      if (AutocompleteSuggestion && AutocompleteSessionToken && Place) {
        return;
      }

      if (!placesLibraryPromise) {
        placesLibraryPromise = google.maps
          .importLibrary("places")
          .then((placesLib) => {
            Place = placesLib.Place;
            AutocompleteSuggestion = placesLib.AutocompleteSuggestion;
            AutocompleteSessionToken = placesLib.AutocompleteSessionToken;
            refreshSessionToken();
          })
          .catch((error) => {
            placesLibraryPromise = null;
            throw error;
          });
      }

      await placesLibraryPromise;
    }

    function attachLazyPlacesLoading() {
      if (!placeAutocomplete) return;

      const warmPlacesLibrary = () => {
        ensurePlacesLibrary().catch((error) => {
          console.warn("Places library unavailable:", error);
        });
      };

      placeAutocomplete.addEventListener("focus", warmPlacesLibrary, { once: true });
      placeAutocomplete.addEventListener("input", warmPlacesLibrary, { once: true });
    }

    async function mountPlaceAutocomplete() {
      await ensurePlacesLibrary();
      mountSearchInput();
    }

    function refreshSessionToken() {
      if (!AutocompleteSessionToken) return;
      sessionToken = new AutocompleteSessionToken();
    }

    function getPlacePredictionLabel(placePrediction) {
      if (!placePrediction) return "";

      const main = placePrediction.mainText?.text || placePrediction.text?.text || "";
      const secondary = placePrediction.secondaryText?.text || "";
      return [main, secondary].filter(Boolean).join(", ");
    }

    function hidePredictionsDropdown() {
      const dropdown = $("predictions-dropdown");
      dropdown.classList.remove("visible");
      dropdown.innerHTML = "";
    }

    function showPredictionsDropdown(suggestions, rawInput) {
      const dropdown = $("predictions-dropdown");
      currentRawInput = rawInput;
      dropdown.innerHTML = "";

      const header = document.createElement("div");
      header.className = "predictions-dropdown-header";
      header.textContent = "Select a suggested address";
      dropdown.appendChild(header);

      suggestions.forEach((suggestion) => {
        const placePrediction = suggestion.placePrediction;
        if (!placePrediction) return;

        const button = document.createElement("button");
        button.type = "button";
        button.className = "prediction-item";
        button.setAttribute("role", "option");

        const mainText = document.createElement("span");
        mainText.className = "prediction-item-main";
        mainText.textContent = placePrediction.mainText?.text || placePrediction.text?.text || "";

        const subText = document.createElement("span");
        subText.className = "prediction-item-sub";
        subText.textContent = placePrediction.secondaryText?.text || "";

        button.appendChild(mainText);
        if (subText.textContent) {
          button.appendChild(subText);
        }

        button.addEventListener("click", async () => {
          hidePredictionsDropdown();
          window.clearTimeout(predictionDebounceTimer);
          predictionRequestId += 1;

          const label = getPlacePredictionLabel(placePrediction);
          if (label) setSearchInputValue(label);

          const place = placePrediction.toPlace();
          await searchByPlace(place);
          refreshSessionToken();
        });

        dropdown.appendChild(button);
      });

      const rawButton = document.createElement("button");
      rawButton.type = "button";
      rawButton.className = "prediction-raw";
      rawButton.textContent = `Use entered address: ${rawInput}`;
      rawButton.addEventListener("click", async () => {
        hidePredictionsDropdown();
        setSearchInputValue(rawInput);
        await searchByAddress(rawInput);
        refreshSessionToken();
      });
      dropdown.appendChild(rawButton);

      dropdown.classList.add("visible");
    }

    async function fetchAddressPredictions(input) {
      try {
        await ensurePlacesLibrary();
      } catch {
        return [];
      }

      if (!AutocompleteSuggestion || !AutocompleteSessionToken) {
        return [];
      }

      const { suggestions } = await AutocompleteSuggestion.fetchAutocompleteSuggestions({
        input,
        sessionToken,
        language: "en-US",
      });
      return suggestions || [];
    }

    async function updateAddressPredictions() {
      const address = getSearchInputValue();

      if (address.length < PREDICTION_MIN_CHARS) {
        hidePredictionsDropdown();
        return;
      }

      const requestId = ++predictionRequestId;

      try {
        const suggestions = await fetchAddressPredictions(address);
        if (requestId !== predictionRequestId) return;

        if (!suggestions.length) {
          hidePredictionsDropdown();
          return;
        }

        showPredictionsDropdown(suggestions, address);
      } catch (error) {
        if (requestId !== predictionRequestId) return;
        hidePredictionsDropdown();
        console.error(error);
      }
    }

    function schedulePredictionUpdate() {
      window.clearTimeout(predictionDebounceTimer);
      predictionDebounceTimer = window.setTimeout(() => {
        updateAddressPredictions();
      }, PREDICTION_DEBOUNCE_MS);
    }

    function attachSearchInputListeners(element) {
      if (!element) return;

      element.addEventListener("input", schedulePredictionUpdate);

      const internalInput = element.querySelector?.("input");
      if (internalInput && internalInput !== element) {
        internalInput.addEventListener("input", schedulePredictionUpdate);
      }
    }

    function getSearchInputValue() {
      if (!placeAutocomplete) return "";
      if (typeof placeAutocomplete.value === "string") {
        return placeAutocomplete.value.trim();
      }
      return String(placeAutocomplete.value ?? "").trim();
    }

    function setSearchInputValue(value) {
      if (!placeAutocomplete) return;

      const text = String(value ?? "");
      if (typeof placeAutocomplete.value === "string") {
        placeAutocomplete.value = text;
        syncSearchInputHeight(placeAutocomplete);
        return;
      }

      try {
        placeAutocomplete.value = text;
      } catch {
        // PlaceAutocompleteElement may not expose a writable value in some browsers.
      }

      const input = placeAutocomplete.querySelector?.("input");
      if (input) input.value = text;
      syncSearchInputHeight(placeAutocomplete);
    }

    function getInitialAddressFromUrl() {
      try {
        const address = new URLSearchParams(window.location.search).get("address");
        if (!address?.trim()) return "";
        return normalizeAddress(address);
      } catch {
        return "";
      }
    }

    async function handleSearchClick() {
      const address = getSearchInputValue();

      if (!address) {
        setStatus("Please enter an address", true);
        return;
      }

      window.clearTimeout(predictionDebounceTimer);
      predictionRequestId += 1;

      setSearchLoading(true);
      setStatus("Fetching address suggestions…");

      try {
        await ensurePlacesLibrary().catch(() => {});
        const suggestions = await fetchAddressPredictions(address);

        if (!suggestions.length) {
          hidePredictionsDropdown();
          setStatus("No suggestions found, searching with entered address");
          setSearchLoading(false);
          await searchByAddress(address);
          refreshSessionToken();
          return;
        }

        showPredictionsDropdown(suggestions, address);
        setStatus(`Found ${suggestions.length} suggestions — select one or use entered address`);
      } catch (error) {
        hidePredictionsDropdown();
        setStatus("Failed to fetch address suggestions, please try again", true);
        console.error(error);
      } finally {
        setSearchLoading(false);
      }
    }

    function escapeHtml(value) {
      return String(value ?? "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    }

    function getProviderName(provider) {
      if (provider.companyName) return provider.companyName;
      return `${provider.firstName || ""} ${provider.lastName || ""}`.trim() || "Unknown Provider";
    }

    function getProviderServiceEntries(provider) {
      if (Array.isArray(provider.serviceItemDetails) && provider.serviceItemDetails.length) {
        return provider.serviceItemDetails
          .map((detail) => ({
            id: detail.serviceId != null ? Number(detail.serviceId) : null,
            name: String(detail.serviceName || "").trim(),
            option: detail,
          }))
          .filter((entry) => entry.name);
      }

      if (Array.isArray(provider.serviceIds) && provider.serviceIds.length) {
        return provider.serviceIds
          .map((id) => {
            const option = getServiceOptionById(id);
            const name = option?.serviceName || String(id);
            return { id: Number(id), name: String(name).trim(), option };
          })
          .filter((entry) => entry.name);
      }

      if (Array.isArray(provider.serviceItems) && provider.serviceItems.length) {
        return provider.serviceItems
          .map((item) => {
            const name = String(item).trim();
            const option = getServiceOptionByName(name);
            return {
              id: option ? Number(option.id) : null,
              name,
              option,
            };
          })
          .filter((entry) => entry.name);
      }

      return [];
    }

    function getProviderAddressLines(provider) {
      const street = normalizeAddress(provider.shippingAddress || provider.addressLine1 || "");
      const postal = String(provider.postalCode || provider.zipCode || provider.zip || "").trim();
      const cityStateParts = [provider.city, provider.state].filter(Boolean);
      let cityStateLine = cityStateParts.join(", ");

      if (postal) {
        cityStateLine = cityStateLine ? `${cityStateLine} ${postal}` : postal;
      }

      const country = normalizeAddress(provider.country || "");
      const lines = [];

      if (street) lines.push(street);
      if (cityStateLine) lines.push(cityStateLine);
      if (country) lines.push(country);

      if (!lines.length) {
        const fallback = normalizeAddress(
          [provider.city, provider.state, provider.country].filter(Boolean).join(", ")
        );
        if (fallback) lines.push(fallback);
      }

      return lines;
    }

    function buildProviderServicesSectionHtml(provider) {
      const serviceEntries = getProviderServiceEntries(provider);
      if (!serviceEntries.length) return "";

      const offerServiceLabel = escapeHtml(config.offerServiceLabel || "Offer Service");
      const serviceTagsHtml = serviceEntries
        .map((entry) => {
          const dataAttr = entry.id ? ` data-option-id="${entry.id}"` : "";
          const colors = getServiceColors(entry.id, entry.option);
          return `<span class="provider-service-tag provider-service-tag--option"${dataAttr}${buildOptionColorStyle(
            colors
          )}>${escapeHtml(entry.name)}</span>`;
        })
        .join("");

      return `
        <div class="provider-services">
          <div class="provider-services-label">${offerServiceLabel}</div>
          <div class="provider-service-tags">${serviceTagsHtml}</div>
        </div>
      `;
    }

    function buildProviderAddressSectionHtml(provider) {
      const addressLines = getProviderAddressLines(provider);
      if (!addressLines.length) return "";

      const addressHtml = addressLines
        .map((line) => `<div class="provider-address-line">${escapeHtml(line)}</div>`)
        .join("");

      return `<div class="provider-address">${addressHtml}</div>`;
    }

    function buildProviderInfoWindowHtml(provider) {
      const name = escapeHtml(getProviderName(provider));
      const distance = getProviderDistance(provider);
      const infoWindowButtonText = escapeHtml(config.infoWindowButtonText || "Request Service");
      const servicesSectionHtml = buildProviderServicesSectionHtml(provider);
      const addressSectionHtml = buildProviderAddressSectionHtml(provider);

      const contactItems = [];

      if (provider.phoneNumber) {
        const phoneRaw = String(provider.phoneNumber).trim();
        const phone = escapeHtml(phoneRaw);
        contactItems.push(`
          <a class="nim-info-window__contact-item" href="tel:${encodeURIComponent(phoneRaw)}">
            <span class="nim-info-window__contact-icon" aria-hidden="true">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.12.86.3 1.7.54 2.5a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.58-1.11a2 2 0 0 1 2.11-.45c.8.24 1.64.42 2.5.54A2 2 0 0 1 22 16.92z"></path>
              </svg>
            </span>
            <span class="nim-info-window__contact-text">${phone}</span>
          </a>
        `);
      }

      if (provider.email) {
        const emailRaw = String(provider.email).trim();
        const email = escapeHtml(emailRaw);
        contactItems.push(`
          <a class="nim-info-window__contact-item" href="mailto:${encodeURIComponent(emailRaw)}">
            <span class="nim-info-window__contact-icon" aria-hidden="true">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="2" y="4" width="20" height="16" rx="2"></rect>
                <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
              </svg>
            </span>
            <span class="nim-info-window__contact-text">${email}</span>
          </a>
        `);
      }

      return `
        <div class="nim-info-window">
          <button type="button" class="nim-info-window__close" aria-label="Close">&times;</button>
          <div class="nim-info-window__head">
            <div class="nim-info-window__title-row">
              <h3 class="nim-info-window__title">${name}</h3>
            </div>
            ${distance != null ? `<div class="nim-info-window__distance">${escapeHtml(formatProviderDistance(distance))}</div>` : ""}
          </div>
          <div class="nim-info-window__body">
            ${servicesSectionHtml}
            ${addressSectionHtml}
            ${contactItems.length ? `<div class="nim-info-window__contact">${contactItems.join("")}</div>` : ""}
          </div>
          <div class="nim-info-window__footer">
            <button type="button" class="nim-info-window__btn request-service-btn" data-provider-id="${provider.id}">${infoWindowButtonText}</button>
          </div>
        </div>
      `;
    }

    function formatProviderDistance(distance) {
      if (distance == null) return "";
      const rounded = Math.round(distance);
      return `${rounded} mi`;
    }

    function normalizeAddress(address) {
      return String(address || "")
        .replace(/United_States/gi, "United States")
        .replace(/_/g, " ")
        .replace(/\s+,/g, ",")
        .replace(/,\s*/g, ", ")
        .replace(/\s+/g, " ")
        .trim();
    }

    function extractLatLng(location) {
      if (!location) return null;

      const lat = typeof location.lat === "function" ? location.lat() : Number(location.lat);
      const lng = typeof location.lng === "function" ? location.lng() : Number(location.lng);

      if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
      return { lat, lng };
    }

    function getProviderLatLng(provider) {
      if (!provider) return null;

      const fromLatLng = extractLatLng({ lat: provider.lat, lng: provider.lng });
      if (fromLatLng) return fromLatLng;

      return extractLatLng({ lat: provider.latitude, lng: provider.longitude });
    }

    function applyProviderCoordinates(provider) {
      const coords = getProviderLatLng(provider);
      if (!coords) return false;

      provider.lat = coords.lat;
      provider.lng = coords.lng;
      return true;
    }

    function clearUserLocationMarker() {
      if (userMarker) {
        userMarker.map = null;
        userMarker = null;
      }
      currentLocation = null;
    }

    function resetMapToDefaultView() {
      if (!map) return;
        map.setCenter(DEFAULT_MAP_CENTER);
        map.setZoom(DEFAULT_MAP_ZOOM);
    }

    function getMapPanel() {
      return $(".map-panel");
    }

    function runWithSuppressedViewportSync(callback) {
      suppressViewportSyncEvents = true;
      callback();
      window.setTimeout(() => {
        suppressViewportSyncEvents = false;
      }, MAP_VIEWPORT_SYNC_DEBOUNCE_MS);
    }

    function applyInitialMapView() {
      if (!map) return;

          lastSyncedBoundsKey = "";
      lastRepairSyncedBoundsKey = "";
      runWithSuppressedViewportSync(() => {
        map.setCenter(DEFAULT_MAP_CENTER);
        map.setZoom(INITIAL_MAP_ZOOM);
      });
    }

    function noteMapInteraction() {}

    function getProviderCountLabel(sortedProviders, mappedCount) {
      const hasFilters = selectedProviderTypes.size > 0 || selectedServiceIds.size > 0;
      const visibleOnMap = countMarkersOnMap(providerMarkers);

      if (hasFilters) return `${sortedProviders.length} shown`;
      if (usesViewportProviderMarkers()) {
        return visibleOnMap > 0
          ? `${visibleOnMap} on map · ${providers.length} total`
          : `${providers.length} total`;
      }
      return mappedCount ? `${mappedCount} on map` : `${providers.length} total`;
    }

    function updateProviderCountLabel(filteredProviders = null) {
      const countEl = $("provider-count");
      if (!countEl || !providers.length) return;

      const providersForCount = filteredProviders || getFilteredProviders();
      const mappedCount = providersForCount.filter((provider) => provider.lat && provider.lng).length;
      const nextText = getProviderCountLabel(providersForCount, mappedCount);
      if (nextText === lastProviderCountText) return;

      lastProviderCountText = nextText;
      countEl.textContent = nextText;
      updateMobileToolbarCount();
    }

    function destroyProviderMarker(marker) {
      if (!marker) return;
      google.maps.event.clearInstanceListeners(marker);
      marker.map = null;
    }

    function setMarkerMap(marker, nextMap) {
      if (!marker || marker.map === nextMap) return;
      marker.map = nextMap;
    }

    function getProviderMarkerColor() {
      // Unified marker color: green for all providers (no longer derived from provider type).
      return "#15803d";
    }

    function bindMapLifecycleControls() {
      handleWindowResize = () => {
        window.clearTimeout(windowResizeTimer);
        windowResizeTimer = window.setTimeout(() => {
          syncInfoWindowLayoutVars();
          if (getMapPanel()?.classList.contains("is-info-window-open")) {
            applyInfoWindowScrollContainer();
          }

          if (!map) return;

          if (isRepairTabActive()) {
            if (!usesViewportRepairMarkers()) return;
            lastRepairSyncedBoundsKey = "";
            scheduleRepairViewportMarkerSync(true);
          } else {
            if (!usesViewportProviderMarkers()) return;
            lastSyncedBoundsKey = "";
            scheduleViewportMarkerSync(true);
          }
        }, 200);
      };
      window.addEventListener("resize", handleWindowResize);
    }

    function teardownNearbyInstallersMap() {
      window.clearTimeout(viewportSyncTimer);
      window.clearTimeout(repairViewportSyncTimer);
      clearMapViewportListeners();
      window.clearTimeout(predictionDebounceTimer);
      clearAllListLoadingStates();
      providerVirtualList?.destroy();
      providerVirtualList = null;
      repairVirtualList?.destroy();
      repairVirtualList = null;
      closeMobileFilterSheet();
      clearGloboInitTimeouts();
      unbindRepairFormSubmitListeners();
      closeProviderInfoWindow();
      clearProviderMarkers();
      clearRepairMarkers();
      clearUserLocationMarker();

      if (handleRootClick) {
        root.removeEventListener("click", handleRootClick);
        handleRootClick = null;
      }

      if (handleDocumentClick) {
        document.removeEventListener("click", handleDocumentClick);
        handleDocumentClick = null;
      }

      window.clearTimeout(windowResizeTimer);
      windowResizeTimer = null;

      if (handleWindowResize) {
        window.removeEventListener("resize", handleWindowResize);
        handleWindowResize = null;
      }

      if (map) {
        google.maps.event.clearInstanceListeners(map);
      }

      if (infoWindow) {
        google.maps.event.clearInstanceListeners(infoWindow);
        infoWindow.close();
        infoWindow = null;
      }

      lastProviderCountText = "";
      map = null;
    }

    function haversineMiles(lat1, lng1, lat2, lng2) {
      const toRad = (deg) => (deg * Math.PI) / 180;
      const R = 3958.8;
      const dLat = toRad(lat2 - lat1);
      const dLng = toRad(lng2 - lng1);
      const a =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
      return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    function getProviderDistance(provider) {
      if (!currentLocation || !provider.lat || !provider.lng) return null;
      return haversineMiles(currentLocation.lat, currentLocation.lng, provider.lat, provider.lng);
    }

    function updateMapMarker(lat, lng, shouldRecenter = true) {
      const position = { lat, lng };
      currentLocation = position;

      if (!userMarker) {
        const pin = new PinElement({
          background: "#ef4444",
          borderColor: "#ffffff",
          glyphColor: "#ffffff",
          scale: 1.1,
        });
        userMarker = new AdvancedMarkerElement({
          map,
          position,
          title: "Your location",
          content: pin.element,
          zIndex: 1000,
        });
      } else {
        userMarker.position = position;
      }

      if (shouldRecenter) {
        runWithSuppressedViewportSync(() => {
          map.setCenter(position);
          map.setZoom(10);
        });
      }

      if (isRepairTabActive()) {
        renderRepairSiteList();
      } else {
        renderProviderList();
      }
    }

    async function fetchNearbyProviders(address, placeId, serviceIds) {
      const response = await fetch(NEARBY_PROVIDER_API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          address: address ?? null,
          placeId: placeId ?? null,
          serviceIds: serviceIds ?? null,
        }),
      });

      if (!response.ok) {
        throw new Error(`API returned ${response.status}`);
      }

      const result = await response.json();
      if (result.code !== 200) {
        throw new Error(result.msg || "Failed to load nearby providers");
      }

      return Array.isArray(result.data) ? result.data : [];
    }

    async function loadProvidersFromNearbyApi(
      address,
      placeId,
      serviceIds,
      loadingMessage,
      prefetchedProviders = null
    ) {
      if (!tabSwitchInProgress) {
        setPageLoading(true, loadingMessage);
      }

      try {
        let nearbyProviders = prefetchedProviders;
        if (nearbyProviders == null) {
          nearbyProviders = await fetchNearbyProviders(address, placeId, serviceIds);
        }
        await yieldToMain();
        activeProviderId = null;
        setActiveProviderCard(null);
        closeProviderInfoWindow();

        listEmptyMessage = "";
        const mappedProviders = await prepareProviders(nearbyProviders, {
          shouldFitMap: true,
        });

        const showNoNearbyMessage = hasActiveSearch && !mappedProviders.length;
        if (showNoNearbyMessage) {
          listEmptyMessage = nearbyProviders.length
            ? "No providers with map coordinates found"
            : "No providers found within 90 km, please click the 'View All Providers' button at the bottom to see all providers";
          renderProviderList();
        } else {
          listEmptyMessage = "";
        }

        setStatus("");

        return mappedProviders;
      } catch (error) {
        setStatus(error.message || "Failed to load service providers", true);
        console.error(error);
        throw error;
      } finally {
        if (!tabSwitchInProgress) {
          setPageLoading(false);
        }
      }
    }

    function resetSearchInput() {
      hidePredictionsDropdown();

      if (!placeAutocomplete) return;

      if (typeof placeAutocomplete.value === "string") {
        placeAutocomplete.value = "";
        return;
      }

      const input = placeAutocomplete.querySelector?.("input");
      if (input) input.value = "";
    }

    function resetProviderFilters() {
      selectedProviderTypes.clear();
      selectedServiceIds.clear();

      $$("[data-provider-type]").forEach((chip) => {
        chip.classList.remove("active");
      });

      $$("[data-service-id]").forEach((chip) => {
        chip.classList.remove("active");
      });
    }

    async function viewAllProviders(prefetchedProviders = null) {
      hidePredictionsDropdown();
      setStatus("");
      resetSearchInput();
      resetProviderFilters();

      hasActiveSearch = false;
      lastSearchAddress = null;
      lastSearchPlaceId = null;
      listEmptyMessage = "";
      clearUserLocationMarker();

      await loadProvidersFromNearbyApi(
        null,
        null,
        null,
        "Loading all providers…",
        prefetchedProviders
      );
    }

    async function loadAllProviders() {
      const prefetched =
        prefetchedAllProvidersPromise != null ? await prefetchedAllProvidersPromise : null;
      prefetchedAllProvidersPromise = null;
      await viewAllProviders(prefetched);
    }

    async function showNearbyProviders(address, placeId = null) {
      hasActiveSearch = true;
      lastSearchAddress = address || null;
      lastSearchPlaceId = placeId || null;

      return loadProvidersFromNearbyApi(
        lastSearchAddress,
        lastSearchPlaceId,
        null,
        "Searching nearby providers…"
      );
    }

    async function buildProviderListFromApi(providerList) {
      const result = [];
      const chunkSize = 300;

      for (let index = 0; index < providerList.length; index += chunkSize) {
        const end = Math.min(index + chunkSize, providerList.length);
        for (let cursor = index; cursor < end; cursor += 1) {
          const provider = providerList[cursor];
          if (applyProviderCoordinates(provider)) {
            result.push(provider);
          }
        }

        if (end < providerList.length) {
          await yieldToMain();
        }
      }

      return result;
    }

    async function prepareProviders(providerList, options = {}) {
      const { shouldFitMap = true } = options;

      providers = await buildProviderListFromApi(providerList);

      rememberProviderTypeColorsFromProviders(providers);
      refreshProviderTypeFilterColors();

      if (usesViewportProviderMarkers()) {
        clearProviderMarkers();
        applyFilters();
        if (shouldFitMap) {
          applyInitialMapView();
        }
        scheduleViewportMarkerSync(true);
        return providers;
      }

      const markersForSearch = getFilteredProviders().slice(0, MAX_SEARCH_MODE_MAP_MARKERS);
      addProviderMarkers(markersForSearch);
      applyFilters();

      const markersToFit = getFilteredProviders().slice(0, MAX_SEARCH_MODE_MAP_MARKERS);
      if (shouldFitMap && markersToFit.length) {
        fitMapToMarkers(markersToFit);
      }

      return providers;
    }

    function ensureProviderMarker(provider) {
      if (!provider?.lat || !provider?.lng) return null;

      if (!providerMarkers.has(provider.id)) {
        addSingleProviderMarker(provider);
      } else {
        setMarkerMap(providerMarkers.get(provider.id), map);
      }

      return providerMarkers.get(provider.id) || null;
    }

    function addSingleProviderMarker(provider) {
      if (!provider.lat || !provider.lng || providerMarkers.has(provider.id)) return;

      const pin = new PinElement({
        background: getProviderMarkerColor(),
        borderColor: "#ffffff",
        glyphColor: "#ffffff",
      });

      const marker = new AdvancedMarkerElement({
        map,
        position: { lat: provider.lat, lng: provider.lng },
        title: getProviderName(provider),
        content: pin.element,
      });

      marker.addListener("click", () => focusProvider(provider, false));
      providerMarkers.set(provider.id, marker);
    }

    function clearProviderMarkers() {
      providerMarkers.forEach((marker) => destroyProviderMarker(marker));
      providerMarkers.clear();
    }

    function closeProviderInfoWindow() {
      infoWindow?.close();
    }

    function getMapPanel() {
      return root.querySelector(".map-panel");
    }

    function syncInfoWindowLayoutVars() {
      const mapPanel = getMapPanel();
      if (!mapPanel) return;

      const panelHeight = mapPanel.clientHeight || 320;
      const panelWidth = mapPanel.clientWidth || 320;
      const maxHeight = Math.max(160, Math.floor(panelHeight * 0.9) - 12);
      const maxWidth = Math.min(320, Math.max(248, panelWidth - 28));

      mapPanel.style.setProperty("--nim-info-window-max-height", `${maxHeight}px`);
      mapPanel.style.setProperty("--nim-info-window-width", `${maxWidth}px`);

      if (infoWindow) {
        infoWindow.setOptions({ maxWidth });
      }
    }

    function applyInfoWindowScrollContainer() {
      const mapPanel = getMapPanel();
      if (!mapPanel) return;

      const maxHeight =
        mapPanel.style.getPropertyValue("--nim-info-window-max-height") ||
        getComputedStyle(mapPanel).getPropertyValue("--nim-info-window-max-height") ||
        "360px";

      mapPanel.querySelectorAll(".gm-style-iw-d").forEach((scrollEl) => {
        scrollEl.style.overflowX = "hidden";
        scrollEl.style.overflowY = "auto";
        scrollEl.style.maxHeight = maxHeight.trim() || "360px";
        scrollEl.style.webkitOverflowScrolling = "touch";
        scrollEl.style.touchAction = "pan-y";
      });
    }

    function centerInfoWindowInMap() {
      if (!map) return;

      const mapDiv = map.getDiv();
      if (!mapDiv) return;

      const mapRect = mapDiv.getBoundingClientRect();
      const mapCenterX = mapRect.left + mapRect.width / 2;
      const mapCenterY = mapRect.top + mapRect.height / 2;
      const infoWindowEl = getMapPanel()?.querySelector(".gm-style-iw-c");
      if (!infoWindowEl) return;

      const infoWindowRect = infoWindowEl.getBoundingClientRect();
      const infoWindowCenterX = infoWindowRect.left + infoWindowRect.width / 2;
      const infoWindowCenterY = infoWindowRect.top + infoWindowRect.height / 2;
      const offsetX = infoWindowCenterX - mapCenterX;
      const offsetY = infoWindowCenterY - mapCenterY;

      if (Math.abs(offsetX) < 1 && Math.abs(offsetY) < 1) return;

      runWithSuppressedViewportSync(() => {
        map.panBy(offsetX, offsetY);
      });
    }

    function prepareInfoWindowViewport() {
      const mapPanel = getMapPanel();
      mapPanel?.classList.add("is-info-window-open");
      syncInfoWindowLayoutVars();
      applyInfoWindowScrollContainer();

      window.requestAnimationFrame(() => {
        centerInfoWindowInMap();
      });
    }

    function openProviderInfoWindow(provider) {
      if (isRepairTabActive() || !provider) return;

      const marker = providerMarkers.get(provider.id);
      if (!marker) return;

      openMapInfoWindow(buildProviderInfoWindowHtml(provider), marker);
    }

    function focusProvider(provider, shouldPan = true) {
      if (!provider?.lat || !provider?.lng) return;

      activeProviderId = provider.id;
      setActiveProviderCard(provider.id);
      ensureProviderMarker(provider);

      if (shouldPan) {
        runWithSuppressedViewportSync(() => {
          map.panTo({ lat: provider.lat, lng: provider.lng });
          map.setZoom(Math.max(map.getZoom(), FOCUS_MAP_ZOOM));
        });
        google.maps.event.addListenerOnce(map, "idle", () => {
          if (usesViewportProviderMarkers()) {
            scheduleViewportMarkerSync(true);
          }
          openProviderInfoWindow(provider);
        });
      } else {
        openProviderInfoWindow(provider);
      }
    }

    function addProviderMarkers(providerList) {
      clearProviderMarkers();
      providerList.forEach((provider) => addSingleProviderMarker(provider));
    }

    function fitMapToMarkers(providerList) {
      const bounds = new google.maps.LatLngBounds();
      let hasPoint = false;

      providerList.forEach((provider) => {
        if (provider.lat && provider.lng) {
          bounds.extend({ lat: provider.lat, lng: provider.lng });
          hasPoint = true;
        }
      });

      if (currentLocation) {
        bounds.extend(currentLocation);
        hasPoint = true;
      }

      if (hasPoint) {
        runWithSuppressedViewportSync(() => {
          map.fitBounds(bounds, 64);
        });
      }
    }

    function renderProviderList() {
      const listEl = $("provider-list");
      const countEl = $("provider-count");

      if (!providers.length) {
        lastProviderCountText = "";
        countEl.textContent = "";
        listEl.classList.remove("provider-list--chunked");
        listEl.innerHTML = listEmptyMessage
          ? `<div class="list-placeholder"><p>${escapeHtml(listEmptyMessage)}</p></div>`
          : "";
        return;
      }

      const filteredProviders = getFilteredProviders();
      let sortedProviders = filteredProviders;

      if (currentLocation) {
        sortedProviders = filteredProviders
          .map((provider) => ({
            provider,
            distance: getProviderDistance(provider),
          }))
          .sort((a, b) => {
            if (a.distance == null && b.distance == null) return 0;
            if (a.distance == null) return 1;
            if (b.distance == null) return -1;
            return a.distance - b.distance;
          })
          .map((entry) => entry.provider);
      }

      updateProviderCountLabel(filteredProviders);

      if (!sortedProviders.length) {
        listEl.classList.remove("provider-list--chunked");
        listEl.innerHTML = `<div class="list-placeholder"><p>No providers match your filters.</p></div>`;
        return;
      }

      const virtualList = getProviderVirtualList();
      virtualList.setActiveId(isMobileFilterSheetOpen() ? null : activeProviderId);
      virtualList.setItems(sortedProviders);
    }

    async function searchByAddress(address, placeId = null) {
      if (!address?.trim()) {
        setStatus("Please enter an address", true);
        return;
      }

      setSearchLoading(true);
      if (isRepairTabActive()) {
        setRepairListLoading(true, "Searching repair sites…");
      } else {
        setListLoading(true, "Searching nearby providers…");
      }
      currentAddress = address.trim();
      setSearchInputValue(currentAddress);
      hidePredictionsDropdown();

      try {
        if (isRepairTabActive()) {
          await showRepairSitesByAddress(currentAddress, placeId);
        } else {
          await showNearbyProviders(currentAddress, placeId);
        }
        setStatus("");
      } catch (error) {
        setStatus(
          error.message ||
            (isRepairTabActive()
              ? "Failed to search repair sites"
              : "Failed to search nearby providers"),
          true
        );
        console.error(error);
      } finally {
        setSearchLoading(false);
        setPageLoading(false);
        setListLoading(false);
        setRepairListLoading(false);
      }
    }

    async function searchByPlace(place) {
      setSearchLoading(true);
      if (isRepairTabActive()) {
        setRepairListLoading(true, "Locating address…");
      } else {
        setListLoading(true, "Locating address…");
      }

      try {
        await ensurePlacesLibrary();
        await place.fetchFields({
          fields: ["displayName", "formattedAddress", "location", "id"],
        });

        const coords = extractLatLng(place.location);
        if (!coords) {
          setStatus("Failed to read address coordinates", true);
          if (isRepairTabActive()) {
            setRepairListLoading(false);
          } else {
            setListLoading(false);
          }
          return;
        }

        const address = place.formattedAddress || place.displayName || "";
        currentAddress = address;

        setSearchInputValue(address);
        updateMapMarker(coords.lat, coords.lng);

        if (isRepairTabActive()) {
          await showRepairSitesByAddress(address, place.id || null);
        } else {
          await showNearbyProviders(address, place.id || null);
        }
      } catch (error) {
        setStatus(
          error.message ||
            (isRepairTabActive()
              ? "Failed to search repair sites"
              : "Failed to search nearby providers"),
          true
        );
        if (isRepairTabActive()) {
          setRepairListLoading(false);
        } else {
          setPageLoading(false);
        }
        console.error(error);
      } finally {
        setSearchLoading(false);
        setPageLoading(false);
        setListLoading(false);
        setRepairListLoading(false);
      }
    }

    function bindProviderListScrollGuards() {
      root.querySelectorAll(".provider-list").forEach((listEl) => {
        if (listEl.dataset.nimScrollGuard === "true") return;
        listEl.dataset.nimScrollGuard = "true";

        listEl.addEventListener(
          "wheel",
          (event) => {
            const canScroll = listEl.scrollHeight > listEl.clientHeight + 1;
            if (!canScroll) return;

            const deltaY = event.deltaY;
            const atTop = listEl.scrollTop <= 0;
            const atBottom = listEl.scrollTop + listEl.clientHeight >= listEl.scrollHeight - 1;

            if ((deltaY < 0 && atTop) || (deltaY > 0 && atBottom)) return;

            event.stopPropagation();
          },
          { passive: true }
        );
      });
    }

    async function initAppInternal() {
      if (!getInitialAddressFromUrl()) {
        prefetchedAllProvidersPromise = fetchNearbyProviders(null, null, null).catch((error) => {
          console.error("NearbyInstallersMap: prefetch providers failed", error);
          return null;
        });
      }

      const mapsLibPromise = google.maps.importLibrary("maps");
      const markerLibPromise = google.maps.importLibrary("marker");
      const serviceOptionsPromise = loadServiceOptions();

      const { Map, InfoWindow: InfoWindowClass } = await mapsLibPromise;
      infoWindow = new InfoWindowClass({ maxWidth: 320 });
      infoWindow.addListener("domready", prepareInfoWindowViewport);
      infoWindow.addListener("close", () => {
        getMapPanel()?.classList.remove("is-info-window-open");
        if (suppressInfoWindowCloseSelectionReset) return;

        activeProviderId = null;
        activeRepairSiteId = null;
        setActiveProviderCard(null);
        setActiveRepairSiteCard(null);
        if (isRepairTabActive()) {
          if (usesViewportRepairMarkers()) {
            scheduleRepairViewportMarkerSync(false);
          } else {
            syncRepairMapMarkersWithFilter();
          }
        } else if (usesViewportProviderMarkers()) {
          scheduleViewportMarkerSync(false);
        } else {
          syncMapMarkersWithFilter();
        }
      });
      syncInfoWindowLayoutVars();
      const markerLib = await markerLibPromise;
      AdvancedMarkerElement = markerLib.AdvancedMarkerElement;
      PinElement = markerLib.PinElement;

      const mapEl = $("map");
      if (!mapEl) {
        throw new Error("Map container not found");
      }

      map = new Map(mapEl, {
        center: DEFAULT_MAP_CENTER,
        zoom: INITIAL_MAP_ZOOM,
        minZoom: 5,
        maxZoom: 16,
        mapId: GOOGLE_MAP_ID,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: true,
        isFractionalZoomEnabled: false,
      });
      bindMapViewportSync();
      bindMapLifecycleControls();
      releaseMapLoadingOverlay();

      mountSearchInput();
      attachLazyPlacesLoading();

      $("search-btn").addEventListener("click", handleSearchClick);
      $("view-all-providers").addEventListener("click", () => {
        viewAllProviders();
      });
      $("view-all-repair-sites")?.addEventListener("click", () => {
        viewAllRepairSites();
      });

      handleDocumentClick = (event) => {
        if (event.target.closest(".nim-info-window__close")) {
          event.preventDefault();
          closeProviderInfoWindow();
          return;
        }

        const requestButton = event.target.closest(".request-service-btn[data-provider-id]");
        if (requestButton && isInstallTabActive()) {
          const provider = providers.find(
            (item) => String(item.id) === String(requestButton.dataset.providerId)
          );
          if (provider) {
            event.preventDefault();
            openRequestServiceModal(provider);
          }
        }
      };

      handleRootClick = (event) => {
        const capsule = $(".search-capsule");
        if (!capsule.contains(event.target)) {
          hidePredictionsDropdown();
        }
      };

      document.addEventListener("click", handleDocumentClick);
      root.addEventListener("click", handleRootClick);

      document.addEventListener("shopify:section:unload", (event) => {
        if (String(event.detail.sectionId) !== String(sectionId)) return;
        teardownNearbyInstallersMap();
        root.dataset.nimInitialized = "false";
      });

      $("request-service-close").addEventListener("click", closeRequestServiceModal);
      $("request-service-modal").addEventListener("click", (event) => {
        if (event.target === $("request-service-modal")) {
          closeRequestServiceModal();
        }
      });
      bindRepairFormSubmitListeners();

      initTabControls();
      initFilterControls();
      initRepairFilterControls();
      bindProviderListScrollGuards();
      initMobileFilterUi();
      await serviceOptionsPromise;
      await yieldToMain();

      const initialAddress = getInitialAddressFromUrl();
      if (initialAddress) {
        activeTab = "install";
        updateTabPanels();
        window.NearbyInstallersMap.scrollSectionIntoView(root);
        setSearchInputValue(initialAddress);
        await searchByAddress(initialAddress);
        return;
      }

      await loadAllProviders();
    }

  initAppInternal()
    .catch((error) => {
    console.error("NearbyInstallersMap init failed:", error);
    setStatus("Failed to initialize map. Please refresh the page.", true);
    })
    .finally(() => {
      releaseMapLoadingOverlay();
      clearAllListLoadingStates();
  });
};
